(function(){"use strict";try{if(typeof document!="undefined"){var t=document.createElement("style");t.appendChild(document.createTextNode('.attendee-avatar[data-v-1d9b6940]{display:flex;align-items:center;justify-content:center;position:relative}.avatar-icon[data-v-1d9b6940]{border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:600;text-transform:uppercase;user-select:none;position:relative;z-index:1;box-sizing:border-box;overflow:hidden}.avatar-image[data-v-1d9b6940]{width:100%;height:100%;object-fit:cover;border-radius:50%;position:absolute;top:0;left:0;transition:opacity .3s ease-in-out}.avatar-initials[data-v-1d9b6940]{position:relative;z-index:2;font-weight:600;text-transform:uppercase}.speaking-ring[data-v-1d9b6940]{position:absolute;border-radius:50%;border:2px solid var(--1b35bcb4);z-index:0;opacity:0;transform-origin:center;transition:opacity .4s ease-out .5s,transform .1s ease-out,border-color .4s ease-out .5s}.attendee-avatar[data-speaking=true] .speaking-ring[data-v-1d9b6940]{opacity:1;transition:opacity .2s ease-in,transform .1s ease-out,border-color .2s ease-in;animation:speaking-pulse-1d9b6940 1.2s ease-in-out infinite;--ring-color: var(--1b35bcb4)}@keyframes speaking-pulse-1d9b6940{0%{box-shadow:0 0 0 0 var(--2b1aafb6)}50%{box-shadow:0 0 0 10px var(--590b6e32)}to{box-shadow:0 0 0 20px var(--1505815e)}}.attendee-avatar.size-small .avatar-icon[data-v-1d9b6940]{width:36px;height:36px;font-size:.875rem}.attendee-avatar.size-small .speaking-ring[data-v-1d9b6940]{width:42px;height:42px}.attendee-avatar.size-medium .avatar-icon[data-v-1d9b6940]{width:80px;height:80px;font-size:1.5rem}.attendee-avatar.size-medium .speaking-ring[data-v-1d9b6940]{width:88px;height:88px}.attendee-avatar.size-large .avatar-icon[data-v-1d9b6940]{width:120px;height:120px;font-size:2.5rem}.attendee-avatar.size-large .speaking-ring[data-v-1d9b6940]{width:130px;height:130px}.control-button[data-v-46a84f32]{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;width:var(--control-size, 48px);height:var(--control-size, 48px);background:transparent;border:none;color:var(--icon-color, white);cursor:pointer;transition:all .2s ease}.control-button[data-v-46a84f32]:hover:not(:disabled){transform:translateY(-2px)}.control-button[data-v-46a84f32]:active:not(:disabled){transform:translateY(0)}.control-button.active[data-v-46a84f32]{color:var(--active-color, white)}.control-button[data-v-46a84f32]:disabled{opacity:.5;cursor:not-allowed}.control-button.danger[data-v-46a84f32]{color:#ea4335}/*! tailwindcss v4.1.14 | MIT License | https://tailwindcss.com */@layer properties{@supports (((-webkit-hyphens:none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-translate-x:0;--tw-translate-y:0;--tw-translate-z:0;--tw-space-y-reverse:0;--tw-border-style:solid;--tw-leading:initial;--tw-font-weight:initial;--tw-tracking:initial;--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000;--tw-backdrop-blur:initial;--tw-backdrop-brightness:initial;--tw-backdrop-contrast:initial;--tw-backdrop-grayscale:initial;--tw-backdrop-hue-rotate:initial;--tw-backdrop-invert:initial;--tw-backdrop-opacity:initial;--tw-backdrop-saturate:initial;--tw-backdrop-sepia:initial;--tw-duration:initial;--tw-ease:initial}}}:root,:host{--assetsdrmclient-color-blue-600:oklch(54.6% .245 262.881);--assetsdrmclient-color-gray-50:oklch(98.5% .002 247.839);--assetsdrmclient-color-gray-100:oklch(96.7% .003 264.542);--assetsdrmclient-color-gray-200:oklch(92.8% .006 264.531);--assetsdrmclient-color-gray-300:oklch(87.2% .01 258.338);--assetsdrmclient-color-gray-400:oklch(70.7% .022 261.325);--assetsdrmclient-color-gray-500:oklch(55.1% .027 264.364);--assetsdrmclient-color-gray-700:oklch(37.3% .034 259.733);--assetsdrmclient-color-gray-800:oklch(27.8% .033 256.848);--assetsdrmclient-color-gray-900:oklch(21% .034 264.665);--assetsdrmclient-color-black:#000;--assetsdrmclient-color-white:#fff;--assetsdrmclient-spacing:.25rem;--assetsdrmclient-text-xs:.75rem;--assetsdrmclient-text-xs--line-height:calc(1/.75);--assetsdrmclient-text-sm:.875rem;--assetsdrmclient-text-sm--line-height:calc(1.25/.875);--assetsdrmclient-text-base:1rem;--assetsdrmclient-text-base--line-height: 1.5 ;--assetsdrmclient-text-lg:1.125rem;--assetsdrmclient-text-lg--line-height:calc(1.75/1.125);--assetsdrmclient-text-xl:1.25rem;--assetsdrmclient-text-xl--line-height:calc(1.75/1.25);--assetsdrmclient-font-weight-normal:400;--assetsdrmclient-font-weight-medium:500;--assetsdrmclient-font-weight-semibold:600;--assetsdrmclient-tracking-tight:-.025em;--assetsdrmclient-radius-lg:.5rem;--assetsdrmclient-radius-xl:.75rem;--assetsdrmclient-radius-2xl:1rem;--assetsdrmclient-radius-3xl:1.5rem;--assetsdrmclient-ease-in:cubic-bezier(.4,0,1,1);--assetsdrmclient-ease-out:cubic-bezier(0,0,.2,1);--assetsdrmclient-ease-in-out:cubic-bezier(.4,0,.2,1);--assetsdrmclient-animate-spin:spin 1s linear infinite;--assetsdrmclient-blur-sm:8px;--assetsdrmclient-blur-md:12px;--assetsdrmclient-default-transition-duration:.15s;--assetsdrmclient-default-transition-timing-function:cubic-bezier(.4,0,.2,1)}.assetsdrmclient\\:pointer-events-none{pointer-events:none}.assetsdrmclient\\:absolute{position:absolute}.assetsdrmclient\\:fixed{position:fixed}.assetsdrmclient\\:relative{position:relative}.assetsdrmclient\\:inset-0{inset:calc(var(--assetsdrmclient-spacing)*0)}.assetsdrmclient\\:-top-1{top:calc(var(--assetsdrmclient-spacing)*-1)}.assetsdrmclient\\:top-0{top:calc(var(--assetsdrmclient-spacing)*0)}.assetsdrmclient\\:top-full{top:100%}.assetsdrmclient\\:-right-4{right:calc(var(--assetsdrmclient-spacing)*-4)}.assetsdrmclient\\:right-0{right:calc(var(--assetsdrmclient-spacing)*0)}.assetsdrmclient\\:right-1{right:calc(var(--assetsdrmclient-spacing)*1)}.assetsdrmclient\\:right-3{right:calc(var(--assetsdrmclient-spacing)*3)}.assetsdrmclient\\:bottom-\\[70px\\]{bottom:70px}.assetsdrmclient\\:left-2{left:calc(var(--assetsdrmclient-spacing)*2)}.assetsdrmclient\\:left-3{left:calc(var(--assetsdrmclient-spacing)*3)}.assetsdrmclient\\:left-20{left:calc(var(--assetsdrmclient-spacing)*20)}.assetsdrmclient\\:z-10{z-index:10}.assetsdrmclient\\:z-50{z-index:50}.assetsdrmclient\\:z-\\[99999\\]{z-index:99999}.assetsdrmclient\\:m-0{margin:calc(var(--assetsdrmclient-spacing)*0)}.assetsdrmclient\\:m-1{margin:calc(var(--assetsdrmclient-spacing)*1)}.assetsdrmclient\\:m-2{margin:calc(var(--assetsdrmclient-spacing)*2)}.assetsdrmclient\\:my-0{margin-block:calc(var(--assetsdrmclient-spacing)*0)}.assetsdrmclient\\:mt-0{margin-top:calc(var(--assetsdrmclient-spacing)*0)}.assetsdrmclient\\:mt-2{margin-top:calc(var(--assetsdrmclient-spacing)*2)}.assetsdrmclient\\:mr-7{margin-right:calc(var(--assetsdrmclient-spacing)*7)}.assetsdrmclient\\:mb-6{margin-bottom:calc(var(--assetsdrmclient-spacing)*6)}.assetsdrmclient\\:ml-0\\.5{margin-left:calc(var(--assetsdrmclient-spacing)*.5)}.assetsdrmclient\\:ml-2{margin-left:calc(var(--assetsdrmclient-spacing)*2)}.assetsdrmclient\\:box-border{box-sizing:border-box}.assetsdrmclient\\:block{display:block}.assetsdrmclient\\:flex{display:flex}.assetsdrmclient\\:h-2\\.5{height:calc(var(--assetsdrmclient-spacing)*2.5)}.assetsdrmclient\\:h-3\\.5{height:calc(var(--assetsdrmclient-spacing)*3.5)}.assetsdrmclient\\:h-4{height:calc(var(--assetsdrmclient-spacing)*4)}.assetsdrmclient\\:h-5{height:calc(var(--assetsdrmclient-spacing)*5)}.assetsdrmclient\\:h-7{height:calc(var(--assetsdrmclient-spacing)*7)}.assetsdrmclient\\:h-8{height:calc(var(--assetsdrmclient-spacing)*8)}.assetsdrmclient\\:h-9{height:calc(var(--assetsdrmclient-spacing)*9)}.assetsdrmclient\\:h-10{height:calc(var(--assetsdrmclient-spacing)*10)}.assetsdrmclient\\:h-14{height:calc(var(--assetsdrmclient-spacing)*14)}.assetsdrmclient\\:h-\\[35px\\]{height:35px}.assetsdrmclient\\:h-\\[76px\\]{height:76px}.assetsdrmclient\\:h-\\[235px\\]{height:235px}.assetsdrmclient\\:h-full{height:100%}.assetsdrmclient\\:w-1\\/2{width:50%}.assetsdrmclient\\:w-2\\.5{width:calc(var(--assetsdrmclient-spacing)*2.5)}.assetsdrmclient\\:w-3\\.5{width:calc(var(--assetsdrmclient-spacing)*3.5)}.assetsdrmclient\\:w-4{width:calc(var(--assetsdrmclient-spacing)*4)}.assetsdrmclient\\:w-5{width:calc(var(--assetsdrmclient-spacing)*5)}.assetsdrmclient\\:w-9{width:calc(var(--assetsdrmclient-spacing)*9)}.assetsdrmclient\\:w-40{width:calc(var(--assetsdrmclient-spacing)*40)}.assetsdrmclient\\:w-50{width:calc(var(--assetsdrmclient-spacing)*50)}.assetsdrmclient\\:w-60{width:calc(var(--assetsdrmclient-spacing)*60)}.assetsdrmclient\\:w-\\[54px\\]{width:54px}.assetsdrmclient\\:w-\\[56px\\]{width:56px}.assetsdrmclient\\:w-\\[392px\\]{width:392px}.assetsdrmclient\\:w-\\[402px\\]{width:402px}.assetsdrmclient\\:w-\\[406px\\]{width:406px}.assetsdrmclient\\:w-\\[450px\\]{width:450px}.assetsdrmclient\\:w-\\[calc\\(100\\%-414px\\)\\]{width:calc(100% - 414px)}.assetsdrmclient\\:w-full{width:100%}.assetsdrmclient\\:max-w-\\[450px\\]{max-width:450px}.assetsdrmclient\\:max-w-\\[960px\\]{max-width:960px}.assetsdrmclient\\:max-w-full{max-width:100%}.assetsdrmclient\\:min-w-\\[20px\\]{min-width:20px}.assetsdrmclient\\:min-w-\\[350px\\]{min-width:350px}.assetsdrmclient\\:flex-1{flex:1}.assetsdrmclient\\:translate-x-0{--tw-translate-x:calc(var(--assetsdrmclient-spacing)*0);translate:var(--tw-translate-x)var(--tw-translate-y)}.assetsdrmclient\\:translate-x-full{--tw-translate-x:100%;translate:var(--tw-translate-x)var(--tw-translate-y)}.assetsdrmclient\\:translate-y-0{--tw-translate-y:calc(var(--assetsdrmclient-spacing)*0);translate:var(--tw-translate-x)var(--tw-translate-y)}.assetsdrmclient\\:translate-y-1{--tw-translate-y:calc(var(--assetsdrmclient-spacing)*1);translate:var(--tw-translate-x)var(--tw-translate-y)}.assetsdrmclient\\:animate-spin{animation:var(--assetsdrmclient-animate-spin)}.assetsdrmclient\\:cursor-pointer{cursor:pointer}.assetsdrmclient\\:appearance-none{appearance:none}.assetsdrmclient\\:flex-col{flex-direction:column}.assetsdrmclient\\:flex-col-reverse{flex-direction:column-reverse}.assetsdrmclient\\:items-center{align-items:center}.assetsdrmclient\\:items-start{align-items:flex-start}.assetsdrmclient\\:justify-around{justify-content:space-around}.assetsdrmclient\\:justify-between{justify-content:space-between}.assetsdrmclient\\:justify-center{justify-content:center}.assetsdrmclient\\:justify-end{justify-content:flex-end}.assetsdrmclient\\:\\!gap-0{gap:calc(var(--assetsdrmclient-spacing)*0)!important}.assetsdrmclient\\:gap-0\\.5{gap:calc(var(--assetsdrmclient-spacing)*.5)}.assetsdrmclient\\:gap-1{gap:calc(var(--assetsdrmclient-spacing)*1)}.assetsdrmclient\\:gap-2{gap:calc(var(--assetsdrmclient-spacing)*2)}.assetsdrmclient\\:gap-3{gap:calc(var(--assetsdrmclient-spacing)*3)}.assetsdrmclient\\:gap-4{gap:calc(var(--assetsdrmclient-spacing)*4)}.assetsdrmclient\\:gap-6{gap:calc(var(--assetsdrmclient-spacing)*6)}.assetsdrmclient\\:gap-8{gap:calc(var(--assetsdrmclient-spacing)*8)}:where(.assetsdrmclient\\:space-y-2>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--assetsdrmclient-spacing)*2)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--assetsdrmclient-spacing)*2)*calc(1 - var(--tw-space-y-reverse)))}:where(.assetsdrmclient\\:space-y-3>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--assetsdrmclient-spacing)*3)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--assetsdrmclient-spacing)*3)*calc(1 - var(--tw-space-y-reverse)))}.assetsdrmclient\\:overflow-hidden{overflow:hidden}.assetsdrmclient\\:rounded{border-radius:.25rem}.assetsdrmclient\\:rounded-2xl{border-radius:var(--assetsdrmclient-radius-2xl)}.assetsdrmclient\\:rounded-3xl{border-radius:var(--assetsdrmclient-radius-3xl)}.assetsdrmclient\\:rounded-\\[20px\\]{border-radius:20px}.assetsdrmclient\\:rounded-full{border-radius:3.40282e38px}.assetsdrmclient\\:rounded-lg{border-radius:var(--assetsdrmclient-radius-lg)}.assetsdrmclient\\:rounded-none{border-radius:0}.assetsdrmclient\\:rounded-xl{border-radius:var(--assetsdrmclient-radius-xl)}.assetsdrmclient\\:border{border-style:var(--tw-border-style);border-width:1px}.assetsdrmclient\\:border-0{border-style:var(--tw-border-style);border-width:0}.assetsdrmclient\\:border-t{border-top-style:var(--tw-border-style);border-top-width:1px}.assetsdrmclient\\:border-b{border-bottom-style:var(--tw-border-style);border-bottom-width:1px}.assetsdrmclient\\:border-l{border-left-style:var(--tw-border-style);border-left-width:1px}.assetsdrmclient\\:border-none{--tw-border-style:none;border-style:none}.assetsdrmclient\\:border-solid{--tw-border-style:solid;border-style:solid}.assetsdrmclient\\:border-\\[\\#1d2939\\]{border-color:#1d2939}.assetsdrmclient\\:border-\\[\\#5f6368\\]{border-color:#5f6368}.assetsdrmclient\\:border-\\[\\#344054\\]{border-color:#344054}.assetsdrmclient\\:border-\\[\\#475467\\]{border-color:#475467}.assetsdrmclient\\:border-gray-200{border-color:var(--assetsdrmclient-color-gray-200)}.assetsdrmclient\\:border-gray-300{border-color:var(--assetsdrmclient-color-gray-300)}.assetsdrmclient\\:border-gray-700{border-color:var(--assetsdrmclient-color-gray-700)}.assetsdrmclient\\:bg-\\[\\#1D2939\\],.assetsdrmclient\\:bg-\\[\\#1d2939\\]{background-color:#1d2939}.assetsdrmclient\\:bg-\\[\\#0040C1\\]{background-color:#0040c1}.assetsdrmclient\\:bg-\\[\\#05603a80\\]{background-color:#05603a80}.assetsdrmclient\\:bg-\\[\\#101828\\]{background-color:#101828}.assetsdrmclient\\:bg-\\[\\#334155\\]{background-color:#334155}.assetsdrmclient\\:bg-\\[\\#344054\\]{background-color:#344054}.assetsdrmclient\\:bg-\\[\\#475467\\]{background-color:#475467}.assetsdrmclient\\:bg-\\[\\#77291780\\]{background-color:#77291780}.assetsdrmclient\\:bg-\\[\\#D92D20\\]{background-color:#d92d20}.assetsdrmclient\\:bg-\\[\\#f04438\\]{background-color:#f04438}.assetsdrmclient\\:bg-black,.assetsdrmclient\\:bg-black\\/80{background-color:var(--assetsdrmclient-color-black)}@supports (color:color-mix(in lab,red,red)){.assetsdrmclient\\:bg-black\\/80{background-color:color-mix(in oklab,var(--assetsdrmclient-color-black)80%,transparent)}}.assetsdrmclient\\:bg-blue-600{background-color:var(--assetsdrmclient-color-blue-600)}.assetsdrmclient\\:bg-gray-50{background-color:var(--assetsdrmclient-color-gray-50)}.assetsdrmclient\\:bg-gray-100{background-color:var(--assetsdrmclient-color-gray-100)}.assetsdrmclient\\:bg-gray-700{background-color:var(--assetsdrmclient-color-gray-700)}.assetsdrmclient\\:bg-gray-800,.assetsdrmclient\\:bg-gray-800\\/70{background-color:var(--assetsdrmclient-color-gray-800)}@supports (color:color-mix(in lab,red,red)){.assetsdrmclient\\:bg-gray-800\\/70{background-color:color-mix(in oklab,var(--assetsdrmclient-color-gray-800)70%,transparent)}}.assetsdrmclient\\:bg-transparent{background-color:#0000}.assetsdrmclient\\:bg-white{background-color:var(--assetsdrmclient-color-white)}.assetsdrmclient\\:p-1{padding:calc(var(--assetsdrmclient-spacing)*1)}.assetsdrmclient\\:p-2{padding:calc(var(--assetsdrmclient-spacing)*2)}.assetsdrmclient\\:p-3{padding:calc(var(--assetsdrmclient-spacing)*3)}.assetsdrmclient\\:p-6{padding:calc(var(--assetsdrmclient-spacing)*6)}.assetsdrmclient\\:px-0\\.5{padding-inline:calc(var(--assetsdrmclient-spacing)*.5)}.assetsdrmclient\\:px-1\\.5{padding-inline:calc(var(--assetsdrmclient-spacing)*1.5)}.assetsdrmclient\\:px-2{padding-inline:calc(var(--assetsdrmclient-spacing)*2)}.assetsdrmclient\\:px-2\\.5{padding-inline:calc(var(--assetsdrmclient-spacing)*2.5)}.assetsdrmclient\\:px-3{padding-inline:calc(var(--assetsdrmclient-spacing)*3)}.assetsdrmclient\\:px-4{padding-inline:calc(var(--assetsdrmclient-spacing)*4)}.assetsdrmclient\\:px-5{padding-inline:calc(var(--assetsdrmclient-spacing)*5)}.assetsdrmclient\\:px-6{padding-inline:calc(var(--assetsdrmclient-spacing)*6)}.assetsdrmclient\\:py-0\\.5{padding-block:calc(var(--assetsdrmclient-spacing)*.5)}.assetsdrmclient\\:py-1{padding-block:calc(var(--assetsdrmclient-spacing)*1)}.assetsdrmclient\\:py-1\\.5{padding-block:calc(var(--assetsdrmclient-spacing)*1.5)}.assetsdrmclient\\:py-2{padding-block:calc(var(--assetsdrmclient-spacing)*2)}.assetsdrmclient\\:py-2\\.5{padding-block:calc(var(--assetsdrmclient-spacing)*2.5)}.assetsdrmclient\\:py-3{padding-block:calc(var(--assetsdrmclient-spacing)*3)}.assetsdrmclient\\:py-4{padding-block:calc(var(--assetsdrmclient-spacing)*4)}.assetsdrmclient\\:py-6{padding-block:calc(var(--assetsdrmclient-spacing)*6)}.assetsdrmclient\\:py-\\[10px\\]{padding-block:10px}.assetsdrmclient\\:pt-0{padding-top:calc(var(--assetsdrmclient-spacing)*0)}.assetsdrmclient\\:pt-4{padding-top:calc(var(--assetsdrmclient-spacing)*4)}.assetsdrmclient\\:pt-\\[120px\\]{padding-top:120px}.assetsdrmclient\\:pr-6{padding-right:calc(var(--assetsdrmclient-spacing)*6)}.assetsdrmclient\\:pr-8{padding-right:calc(var(--assetsdrmclient-spacing)*8)}.assetsdrmclient\\:pl-0{padding-left:calc(var(--assetsdrmclient-spacing)*0)}.assetsdrmclient\\:pl-2{padding-left:calc(var(--assetsdrmclient-spacing)*2)}.assetsdrmclient\\:pl-6{padding-left:calc(var(--assetsdrmclient-spacing)*6)}.assetsdrmclient\\:pl-9{padding-left:calc(var(--assetsdrmclient-spacing)*9)}.assetsdrmclient\\:text-center{text-align:center}.assetsdrmclient\\:text-left{text-align:left}.assetsdrmclient\\:text-base{font-size:var(--assetsdrmclient-text-base);line-height:var(--tw-leading,var(--assetsdrmclient-text-base--line-height))}.assetsdrmclient\\:text-lg{font-size:var(--assetsdrmclient-text-lg);line-height:var(--tw-leading,var(--assetsdrmclient-text-lg--line-height))}.assetsdrmclient\\:text-sm{font-size:var(--assetsdrmclient-text-sm);line-height:var(--tw-leading,var(--assetsdrmclient-text-sm--line-height))}.assetsdrmclient\\:text-xl{font-size:var(--assetsdrmclient-text-xl);line-height:var(--tw-leading,var(--assetsdrmclient-text-xl--line-height))}.assetsdrmclient\\:text-xs{font-size:var(--assetsdrmclient-text-xs);line-height:var(--tw-leading,var(--assetsdrmclient-text-xs--line-height))}.assetsdrmclient\\:text-\\[12px\\]{font-size:12px}.assetsdrmclient\\:text-\\[13px\\]{font-size:13px}.assetsdrmclient\\:leading-5{--tw-leading:calc(var(--assetsdrmclient-spacing)*5);line-height:calc(var(--assetsdrmclient-spacing)*5)}.assetsdrmclient\\:leading-\\[18px\\]{--tw-leading:18px;line-height:18px}.assetsdrmclient\\:font-medium{--tw-font-weight:var(--assetsdrmclient-font-weight-medium);font-weight:var(--assetsdrmclient-font-weight-medium)}.assetsdrmclient\\:font-normal{--tw-font-weight:var(--assetsdrmclient-font-weight-normal);font-weight:var(--assetsdrmclient-font-weight-normal)}.assetsdrmclient\\:font-semibold{--tw-font-weight:var(--assetsdrmclient-font-weight-semibold);font-weight:var(--assetsdrmclient-font-weight-semibold)}.assetsdrmclient\\:tracking-tight{--tw-tracking:var(--assetsdrmclient-tracking-tight);letter-spacing:var(--assetsdrmclient-tracking-tight)}.assetsdrmclient\\:whitespace-nowrap{white-space:nowrap}.assetsdrmclient\\:text-\\[\\#1D2939\\]{color:#1d2939}.assetsdrmclient\\:text-\\[\\#004EEB\\]{color:#004eeb}.assetsdrmclient\\:text-\\[\\#6b7280\\]{color:#6b7280}.assetsdrmclient\\:text-\\[\\#32d583\\]{color:#32d583}.assetsdrmclient\\:text-\\[\\#D92D20\\]{color:#d92d20}.assetsdrmclient\\:text-\\[\\#a8c7fa\\]{color:#a8c7fa}.assetsdrmclient\\:text-\\[\\#f04438\\]{color:#f04438}.assetsdrmclient\\:text-blue-600{color:var(--assetsdrmclient-color-blue-600)}.assetsdrmclient\\:text-gray-400{color:var(--assetsdrmclient-color-gray-400)}.assetsdrmclient\\:text-gray-500{color:var(--assetsdrmclient-color-gray-500)}.assetsdrmclient\\:text-gray-700{color:var(--assetsdrmclient-color-gray-700)}.assetsdrmclient\\:text-gray-900{color:var(--assetsdrmclient-color-gray-900)}.assetsdrmclient\\:text-white{color:var(--assetsdrmclient-color-white)}.assetsdrmclient\\:opacity-0{opacity:0}.assetsdrmclient\\:opacity-25{opacity:.25}.assetsdrmclient\\:opacity-75{opacity:.75}.assetsdrmclient\\:opacity-100{opacity:1}.assetsdrmclient\\:shadow-\\[-2px_0_8px_rgba\\(0\\,0\\,0\\,0\\.05\\)\\]{--tw-shadow:-2px 0 8px var(--tw-shadow-color,#0000000d);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.assetsdrmclient\\:shadow-sm{--tw-shadow:0 1px 3px 0 var(--tw-shadow-color,#0000001a),0 1px 2px -1px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.assetsdrmclient\\:shadow-xl{--tw-shadow:0 20px 25px -5px var(--tw-shadow-color,#0000001a),0 8px 10px -6px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.assetsdrmclient\\:backdrop-blur-md{--tw-backdrop-blur:blur(var(--assetsdrmclient-blur-md));-webkit-backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,);backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,)}.assetsdrmclient\\:backdrop-blur-sm{--tw-backdrop-blur:blur(var(--assetsdrmclient-blur-sm));-webkit-backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,);backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,)}.assetsdrmclient\\:transition{transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to,opacity,box-shadow,transform,translate,scale,rotate,filter,-webkit-backdrop-filter,backdrop-filter,display,content-visibility,overlay,pointer-events;transition-timing-function:var(--tw-ease,var(--assetsdrmclient-default-transition-timing-function));transition-duration:var(--tw-duration,var(--assetsdrmclient-default-transition-duration))}.assetsdrmclient\\:transition-all{transition-property:all;transition-timing-function:var(--tw-ease,var(--assetsdrmclient-default-transition-timing-function));transition-duration:var(--tw-duration,var(--assetsdrmclient-default-transition-duration))}.assetsdrmclient\\:transition-colors{transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to;transition-timing-function:var(--tw-ease,var(--assetsdrmclient-default-transition-timing-function));transition-duration:var(--tw-duration,var(--assetsdrmclient-default-transition-duration))}.assetsdrmclient\\:transition-transform{transition-property:transform,translate,scale,rotate;transition-timing-function:var(--tw-ease,var(--assetsdrmclient-default-transition-timing-function));transition-duration:var(--tw-duration,var(--assetsdrmclient-default-transition-duration))}.assetsdrmclient\\:duration-150{--tw-duration:.15s;transition-duration:.15s}.assetsdrmclient\\:duration-200{--tw-duration:.2s;transition-duration:.2s}.assetsdrmclient\\:duration-300{--tw-duration:.3s;transition-duration:.3s}.assetsdrmclient\\:ease-in{--tw-ease:var(--assetsdrmclient-ease-in);transition-timing-function:var(--assetsdrmclient-ease-in)}.assetsdrmclient\\:ease-in-out{--tw-ease:var(--assetsdrmclient-ease-in-out);transition-timing-function:var(--assetsdrmclient-ease-in-out)}.assetsdrmclient\\:ease-out{--tw-ease:var(--assetsdrmclient-ease-out);transition-timing-function:var(--assetsdrmclient-ease-out)}.assetsdrmclient\\:outline-none{--tw-outline-style:none;outline-style:none}@media (hover:hover){.assetsdrmclient\\:hover\\:bg-\\[\\#b91c1c\\]:hover{background-color:#b91c1c}}.assetsdrmclient\\:active\\:bg-\\[\\#991b1b\\]:active{background-color:#991b1b}:root{--breakpoint-medium:1024px;--primary-25:#fcfaff;--primary-50:#f9f5ff;--primary-100:#f4ebff;--primary-200:#e9d7fe;--primary-300:#d6bbfb;--primary-400:#b692f6;--primary-500:#9e77ed;--primary-600:#7f56d9;--primary-700:#6941c6;--primary-800:#53389e;--primary-900:#42307d;--gray-25:#fcfdfd;--gray-50:#f9fafb;--gray-100:#f2f4f7;--gray-200:#eaecf0;--gray-300:#d0d5dd;--gray-400:#98a2b3;--gray-500:#667085;--gray-600:#475467;--gray-700:#344054;--gray-800:#1d2939;--gray-900:#101828}.p-component{font-family:var(--font-family)!important}.p-inputtext:enabled:focus{box-shadow:0 0 0 1px var(--primary-500)!important;border-color:var(--primary-500)!important}@property --tw-translate-x{syntax:"*";inherits:false;initial-value:0}@property --tw-translate-y{syntax:"*";inherits:false;initial-value:0}@property --tw-translate-z{syntax:"*";inherits:false;initial-value:0}@property --tw-space-y-reverse{syntax:"*";inherits:false;initial-value:0}@property --tw-border-style{syntax:"*";inherits:false;initial-value:solid}@property --tw-leading{syntax:"*";inherits:false}@property --tw-font-weight{syntax:"*";inherits:false}@property --tw-tracking{syntax:"*";inherits:false}@property --tw-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:"*";inherits:false}@property --tw-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:"*";inherits:false}@property --tw-inset-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-ring-color{syntax:"*";inherits:false}@property --tw-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:"*";inherits:false}@property --tw-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:"*";inherits:false}@property --tw-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:"*";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-backdrop-blur{syntax:"*";inherits:false}@property --tw-backdrop-brightness{syntax:"*";inherits:false}@property --tw-backdrop-contrast{syntax:"*";inherits:false}@property --tw-backdrop-grayscale{syntax:"*";inherits:false}@property --tw-backdrop-hue-rotate{syntax:"*";inherits:false}@property --tw-backdrop-invert{syntax:"*";inherits:false}@property --tw-backdrop-opacity{syntax:"*";inherits:false}@property --tw-backdrop-saturate{syntax:"*";inherits:false}@property --tw-backdrop-sepia{syntax:"*";inherits:false}@property --tw-duration{syntax:"*";inherits:false}@property --tw-ease{syntax:"*";inherits:false}@keyframes spin{to{transform:rotate(360deg)}}.permission-prompt[data-v-39df96a1]{position:relative;width:100%;height:100%}.permission-modal-overlay[data-v-39df96a1]{position:fixed;inset:0;background:#0009;display:flex;align-items:center;justify-content:center;z-index:99999;backdrop-filter:blur(4px)}.permission-modal[data-v-39df96a1]{background:#fff;border-radius:12px;box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a;max-width:800px;width:90%;max-height:90vh;overflow:hidden;position:relative;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif}.close-button[data-v-39df96a1]{position:absolute;top:16px;right:16px;background:none;border:none;cursor:pointer;padding:8px;color:#6b7280;border-radius:6px;transition:all .2s;display:flex;align-items:center;justify-content:center;z-index:10}.close-button[data-v-39df96a1]:hover{background:#f3f4f6;color:#374151}.permission-modal-content[data-v-39df96a1]{display:flex;min-height:400px}.illustration-section[data-v-39df96a1]{flex:1;display:flex;align-items:center;justify-content:center;padding:32px 24px}.safari-illustration[data-v-39df96a1],.chrome-illustration[data-v-39df96a1]{display:flex;align-items:center;justify-content:center}.safari-illustration svg[data-v-39df96a1],.chrome-illustration svg[data-v-39df96a1]{max-width:100%;height:auto}.content-section[data-v-39df96a1]{flex:1;padding:48px 32px 32px;display:flex;flex-direction:column;justify-content:center}.modal-title[data-v-39df96a1]{font-size:20px;font-weight:500;color:#1f2937;margin:0 0 16px;line-height:1.4}.modal-message[data-v-39df96a1]{font-size:14px;color:#6b7280;margin:0 0 32px;line-height:1.5}.instructions[data-v-39df96a1]{margin-top:8px}.instruction-list[data-v-39df96a1]{display:flex;flex-direction:column;gap:20px}.instruction-item[data-v-39df96a1]{display:flex;gap:16px;align-items:flex-start}.step-number[data-v-39df96a1]{width:24px;height:24px;border-radius:50%;background:#1976d2;color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:600;flex-shrink:0;margin-top:2px}.step-text[data-v-39df96a1]{flex:1;font-size:14px;line-height:1.5;color:#374151}.inline-icon[data-v-39df96a1]{display:inline;vertical-align:middle;color:#6b7280;margin:0 4px}@media (max-width: 1024px){.permission-modal[data-v-39df96a1]{max-width:700px}}@media (max-width: 768px){.permission-modal[data-v-39df96a1]{max-width:95%;margin:16px}.permission-modal-content[data-v-39df96a1]{flex-direction:column;min-height:auto}.illustration-section[data-v-39df96a1]{padding:24px 16px;min-height:200px}.content-section[data-v-39df96a1]{padding:24px 24px 32px}.modal-title[data-v-39df96a1]{font-size:18px}.safari-illustration svg[data-v-39df96a1],.chrome-illustration svg[data-v-39df96a1]{width:250px;height:250px}}@media (max-width: 480px){.permission-modal[data-v-39df96a1]{width:calc(100% - 32px);margin:16px}.content-section[data-v-39df96a1]{padding:20px 20px 28px}.modal-title[data-v-39df96a1]{font-size:16px}.modal-message[data-v-39df96a1],.step-text[data-v-39df96a1]{font-size:13px}.safari-illustration svg[data-v-39df96a1],.chrome-illustration svg[data-v-39df96a1]{width:200px;height:200px}.instruction-item[data-v-39df96a1]{gap:12px}.instruction-list[data-v-39df96a1]{gap:16px}}.audio-meter-container[data-v-908e1937]{width:100%;padding:12px 6px;display:flex;align-items:center;gap:8px;box-sizing:border-box}.mic-icon[data-v-908e1937]{display:flex;align-items:center;justify-content:center;opacity:.8;flex-shrink:0;min-width:24px;width:auto}.audio-meter-bar-background[data-v-908e1937]{flex-grow:1;height:4px;background-color:#fff3;border-radius:2px;position:relative;width:100%}.audio-meter-bar-fill[data-v-908e1937]{position:absolute;height:100%;background-color:#fff;border-radius:2px;transition:width .05s ease-out}.audio-meter-thumb[data-v-908e1937]{position:absolute;width:10px;height:10px;background-color:#fff;border-radius:50%;transform:translate(-50%,-50%);top:50%;box-shadow:0 1px 2px #0000004d;transition:left .05s ease-out}')),document.head.appendChild(t)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
var kt = Object.defineProperty, yt = Object.defineProperties;
var St = Object.getOwnPropertyDescriptors;
var Ue = Object.getOwnPropertySymbols;
var bt = Object.prototype.hasOwnProperty, Et = Object.prototype.propertyIsEnumerable;
var Oe = (r, e) => (e = Symbol[r]) ? e : Symbol.for("Symbol." + r);
var Te = (r, e, a) => e in r ? kt(r, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : r[e] = a, W = (r, e) => {
  for (var a in e || (e = {}))
    bt.call(e, a) && Te(r, a, e[a]);
  if (Ue)
    for (var a of Ue(e))
      Et.call(e, a) && Te(r, a, e[a]);
  return r;
}, ae = (r, e) => yt(r, St(e));
var de = (r, e, a) => Te(r, typeof e != "symbol" ? e + "" : e, a);
var k = (r, e, a) => new Promise((n, s) => {
  var o = (v) => {
    try {
      p(a.next(v));
    } catch (l) {
      s(l);
    }
  }, w = (v) => {
    try {
      p(a.throw(v));
    } catch (l) {
      s(l);
    }
  }, p = (v) => v.done ? n(v.value) : Promise.resolve(v.value).then(o, w);
  p((a = a.apply(r, e)).next());
});
var $e = (r, e, a) => (e = r[Oe("asyncIterator")]) ? e.call(r) : (r = r[Oe("iterator")](), e = {}, a = (n, s) => (s = r[n]) && (e[n] = (o) => new Promise((w, p, v) => (o = s.call(r, o), v = o.done, Promise.resolve(o.value).then((l) => w({ value: l, done: v }), p)))), a("next"), a("return"), e);
import { getCurrentInstance as Je, hasInjectionContext as Ct, inject as ke, ref as b, toValue as Ge, watch as H, provide as Mt, isRef as Pt, getCurrentScope as Tt, computed as A, shallowRef as ee, onBeforeUnmount as At, onUnmounted as te, watchEffect as ce, onMounted as Xe, defineComponent as ye, useCssVars as Ft, createElementBlock as Z, openBlock as V, normalizeClass as Qe, createElementVNode as g, createCommentVNode as Ae, normalizeStyle as re, toDisplayString as Y, renderSlot as Dt, createBlock as Be, Teleport as Ve, withModifiers as qe, createTextVNode as He, createVNode as xt } from "vue";
import { a as Rt, R as j, T as X, D as jt, L as It, o as _t } from "./live-vendor-BylJtbi3.js";
import { _ as Se } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { c as Nt } from "./SpeakerIcon.vue_vue_type_script_setup_true_lang-B7QhZ13r.js";
import { A as Ze, b as Lt, k as ge } from "./index-BKMcmhwk.js";
const ne = /* @__PURE__ */ new WeakMap(), zt = (...r) => {
  var e;
  const a = r[0], n = (e = Je()) == null ? void 0 : e.proxy;
  if (n == null && !Ct())
    throw new Error("injectLocal must be called in setup");
  return n && ne.has(n) && a in ne.get(n) ? ne.get(n)[a] : ke(...r);
};
function Ut(r, e) {
  var a;
  const n = (a = Je()) == null ? void 0 : a.proxy;
  if (n == null)
    throw new Error("provideLocal must be called in setup");
  ne.has(n) || ne.set(n, /* @__PURE__ */ Object.create(null));
  const s = ne.get(n);
  return s[r] = e, Mt(r, e);
}
function xe(r, e) {
  const a = Symbol(r.name || "InjectionState"), n = void 0;
  return [(...w) => {
    const p = r(...w);
    return Ut(a, p), p;
  }, () => zt(a, n)];
}
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
const We = () => {
};
function Ot(r, e) {
  function a(...n) {
    return new Promise((s, o) => {
      Promise.resolve(r(() => e.apply(this, n), { fn: e, thisArg: this, args: n })).then(s).catch(o);
    });
  }
  return a;
}
function $t(...r) {
  let e = 0, a, n = !0, s = We, o, w, p, v, l;
  !Pt(r[0]) && typeof r[0] == "object" ? { delay: w, trailing: p = !0, leading: v = !0, rejectOnCancel: l = !1 } = r[0] : [w, p = !0, v = !0, l = !1] = r;
  const u = () => {
    a && (clearTimeout(a), a = void 0, s(), s = We);
  };
  return (h) => {
    const i = Ge(w), m = Date.now() - e, c = () => o = h();
    return u(), i <= 0 ? (e = Date.now(), c()) : (m > i && (v || !n) ? (e = Date.now(), c()) : p && (o = new Promise((C, y) => {
      s = l ? y : C, a = setTimeout(() => {
        e = Date.now(), n = !0, C(c()), u();
      }, Math.max(0, i - m));
    })), !v && !a && (a = setTimeout(() => n = !0, i)), n = !1, o);
  };
}
function Bt(r, e = 200, a = !1, n = !0, s = !1) {
  return Ot(
    $t(e, a, n, s),
    r
  );
}
function Va(r, e = 200, a = !0, n = !0) {
  if (e <= 0)
    return r;
  const s = b(Ge(r)), o = Bt(() => {
    s.value = r.value;
  }, e, a, n);
  return H(r, () => o()), s;
}
const se = /* @__PURE__ */ new Map();
function Vt(r) {
  const e = Tt();
  function a(p) {
    var v;
    const l = se.get(r) || /* @__PURE__ */ new Set();
    l.add(p), se.set(r, l);
    const u = () => s(p);
    return (v = e == null ? void 0 : e.cleanups) == null || v.push(u), u;
  }
  function n(p) {
    function v(...l) {
      s(v), p(...l);
    }
    return a(v);
  }
  function s(p) {
    const v = se.get(r);
    v && (v.delete(p), v.size || o());
  }
  function o() {
    se.delete(r);
  }
  function w(p, v) {
    var l;
    (l = se.get(r)) == null || l.forEach((u) => u(p, v));
  }
  return { on: a, once: n, off: s, emit: w, reset: o };
}
const [qa, qt] = xe(
  (r = "attendee") => {
    const e = b({
      role: r,
      isLive: !1,
      title: "",
      description: "",
      startedAt: null,
      attendeeCount: 0,
      host: null
    }), a = A(() => e.value.role), n = A(() => e.value.isLive), s = A(() => e.value.role === "host"), o = A(() => e.value.role === "attendee"), w = A(() => e.value.attendeeCount), p = A(() => e.value.host);
    return {
      state: e,
      role: a,
      isLive: n,
      isHost: s,
      isAttendee: o,
      attendeeCount: w,
      host: p,
      setRole: (i) => {
        e.value.role = i;
      },
      setLive: (i) => {
        e.value.isLive = i, i && !e.value.startedAt ? e.value.startedAt = /* @__PURE__ */ new Date() : i || (e.value.startedAt = null);
      },
      setStreamInfo: (i, m) => {
        e.value.title = i, e.value.description = m;
      },
      setHost: (i) => {
        e.value.host = i;
      },
      updateAttendeeCount: (i) => {
        e.value.attendeeCount = i;
      }
    };
  }
);
function Ha() {
  const r = qt();
  if (!r)
    throw new Error("useStreamContext must be used within a StreamProvider");
  return r;
}
const [Ht, Zt] = xe(
  (r) => ee(r)
);
function Wt() {
  return Zt();
}
function K() {
  const r = Wt();
  if (!r)
    throw new Error(
      "Room context not found. Please ensure useProvideRoomContext() is called in a parent component."
    );
  return r;
}
function Za(r = {}) {
  const e = r.room || new Rt(r.roomOptions), a = Ht(e);
  return At(() => k(this, null, function* () {
    if (a.value && a.value.state !== "disconnected")
      try {
        yield a.value.disconnect();
      } catch (n) {
      }
  })), {
    room: a
  };
}
let oe = null;
function we(r = {}) {
  if (oe)
    return oe;
  const { skipAutoEnable: e = !1, enabledControls: a = [] } = r, n = b(!1), s = b(!1), o = b(!1), w = b({ state: "unknown" }), p = b({
    state: "unknown"
  }), v = b({
    state: "unknown"
  }), l = (M, S, x) => {
    const F = M === "camera" ? w : M === "microphone" ? p : v;
    F.value = {
      state: S,
      error: x,
      lastAttempt: /* @__PURE__ */ new Date()
    };
  }, u = ee(null), t = ee(null), h = ee(null), i = b(""), m = b(""), c = b(""), C = () => {
    var M;
    return (M = u.value) == null ? void 0 : M.getVideoTracks()[0];
  }, y = () => {
    var M;
    return (M = t.value) == null ? void 0 : M.getAudioTracks()[0];
  }, f = () => {
    var M;
    return (M = h.value) == null ? void 0 : M.getVideoTracks()[0];
  }, E = (M) => k(this, null, function* () {
    if (M !== n.value)
      if (M)
        try {
          u.value && (u.value.getTracks().forEach((x) => {
            x.readyState === "live" && x.stop();
          }), u.value = null);
          const S = yield navigator.mediaDevices.getUserMedia({
            video: {
              deviceId: i.value ? { exact: i.value } : void 0,
              width: { ideal: 1280 },
              height: { ideal: 720 }
            }
          });
          return u.value = S, n.value = !0, l("camera", "granted"), Promise.resolve();
        } catch (S) {
          return S instanceof Error && (S.name === "NotAllowedError" ? l(
            "camera",
            "denied",
            "Camera access denied by user"
          ) : S.name === "NotFoundError" ? l(
            "camera",
            "denied",
            "No camera device found"
          ) : l("camera", "unknown", S.message)), n.value = !1, Promise.reject(S);
        }
      else
        return u.value && (u.value.getTracks().forEach((x, F) => {
          x.readyState === "live" && x.stop();
        }), u.value = null), n.value = !1, Promise.resolve();
  }), R = () => k(this, null, function* () {
    return E(!n.value);
  }), _ = (M) => k(this, null, function* () {
    if (M !== s.value)
      if (M)
        try {
          t.value && (t.value.getTracks().forEach((x) => {
            x.readyState === "live" && x.stop();
          }), t.value = null);
          const S = yield navigator.mediaDevices.getUserMedia({
            audio: ae(W({}, De), {
              deviceId: m.value ? { exact: m.value } : void 0
            })
          });
          return t.value = S, s.value = !0, l("microphone", "granted"), Promise.resolve();
        } catch (S) {
          return S instanceof Error && (S.name === "NotAllowedError" ? l(
            "microphone",
            "denied",
            "Microphone access denied by user"
          ) : S.name === "NotFoundError" ? l(
            "microphone",
            "denied",
            "No microphone device found"
          ) : l("microphone", "unknown", S.message)), s.value = !1, Promise.reject(S);
        }
      else
        return t.value && (t.value.getTracks().forEach((S) => {
          S.readyState === "live" && S.stop();
        }), t.value = null), s.value = !1, Promise.resolve();
  }), L = () => k(this, null, function* () {
    return _(!s.value);
  }), z = (M) => k(this, null, function* () {
    if (M !== o.value)
      if (M)
        try {
          if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia)
            throw new Error("Screen sharing is not supported in this browser");
          h.value && (h.value.getTracks().forEach((F) => F.stop()), h.value = null);
          const S = yield navigator.mediaDevices.getDisplayMedia({
            video: {
              width: { ideal: 1920 },
              height: { ideal: 1080 },
              frameRate: { ideal: 30 }
            },
            audio: !1
          }), x = S.getVideoTracks()[0];
          return x && x.addEventListener("ended", () => {
            z(!1);
          }), h.value = S, o.value = !0, l("screenshare", "granted"), Promise.resolve();
        } catch (S) {
          return S && typeof S == "object" && "name" in S ? S.name === "NotAllowedError" ? l(
            "screenshare",
            "prompt",
            // Keep as prompt to allow immediate retry
            "Screen sharing cancelled by user"
          ) : S.name === "NotSupportedError" ? l(
            "screenshare",
            "denied",
            "Screen sharing not supported in this browser"
          ) : S.name === "NotFoundError" ? l(
            "screenshare",
            "denied",
            "No screen sharing source available"
          ) : l(
            "screenshare",
            "unknown",
            S.message || "Unknown screen share error"
          ) : l(
            "screenshare",
            "unknown",
            "Unknown screen share error"
          ), o.value = !1, Promise.reject(S);
        }
      else
        return h.value && (h.value.getTracks().forEach((S) => S.stop()), h.value = null), o.value = !1, Promise.resolve();
  }), D = () => k(this, null, function* () {
    return z(!o.value);
  }), T = (M, S) => {
    M === "camera" ? i.value !== S && (i.value = S, n.value && (u.value && (u.value.getTracks().forEach((F, P) => {
      F.readyState === "live" && F.stop();
    }), u.value = null), setTimeout(() => {
      navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: { exact: S },
          width: { ideal: 1280 },
          height: { ideal: 720 }
        }
      }).then((x) => {
        u.value = x, n.value = !0;
      }).catch((x) => {
      });
    }, 100))) : M === "microphone" ? (m.value = S, s.value && _(!0).catch(console.error)) : M === "speaker" && (c.value = S);
  }, N = () => {
    u.value && (u.value.getTracks().forEach((M) => {
      M.readyState === "live" && M.stop();
    }), u.value = null), t.value && (t.value.getTracks().forEach((M) => {
      M.readyState === "live" && M.stop();
    }), t.value = null), h.value && (h.value.getTracks().forEach((M) => {
      M.readyState === "live" && M.stop();
    }), h.value = null), n.value = !1, s.value = !1, o.value = !1;
  };
  te(() => {
    oe === U && (N(), oe = null);
  });
  const U = {
    // Media states
    isCameraEnabled: n,
    isMicrophoneEnabled: s,
    isScreenShareEnabled: o,
    // Browser permission states
    cameraPermission: w,
    microphonePermission: p,
    screenSharePermission: v,
    // Media streams
    cameraStream: u,
    microphoneStream: t,
    screenShareStream: h,
    // Selected devices
    selectedCamera: i,
    selectedMicrophone: m,
    selectedSpeaker: c,
    // Media control methods
    toggleCamera: R,
    toggleMicrophone: L,
    toggleScreenShare: D,
    setCameraEnabled: E,
    setMicrophoneEnabled: _,
    setScreenShareEnabled: z,
    setDeviceSelection: T,
    // Get current tracks
    getCameraTrack: C,
    getMicrophoneTrack: y,
    getScreenShareTrack: f,
    // Permission management
    updateBrowserPermission: l,
    // Cleanup
    cleanup: N
  };
  return oe = U, e || setTimeout(() => k(this, null, function* () {
    const M = u.value && n.value, S = t.value && s.value, x = a.includes("camera") && !M, F = a.includes("microphone") && !S;
    if (!(!x && !F) && !(M && S))
      try {
        const P = yield navigator.mediaDevices.getUserMedia({
          video: x ? {
            deviceId: i.value ? { exact: i.value } : void 0,
            width: { ideal: 1280 },
            height: { ideal: 720 }
          } : !1,
          audio: F ? ae(W({}, De), {
            deviceId: m.value ? { exact: m.value } : void 0
          }) : !1
        }), $ = P.getVideoTracks(), le = P.getAudioTracks();
        x && $.length > 0 && (u.value && u.value.getTracks().forEach((J) => {
          J.readyState === "live" && J.stop();
        }), u.value = new MediaStream([$[0]]), n.value = !0, l("camera", "granted")), F && le.length > 0 && (t.value && t.value.getTracks().forEach((J) => {
          J.readyState === "live" && J.stop();
        }), t.value = new MediaStream([le[0]]), s.value = !0, l("microphone", "granted"));
      } catch (P) {
        P && typeof P == "object" && "name" in P && P.name === "NotAllowedError" && (x && l(
          "camera",
          "denied",
          "Camera access denied by user"
        ), F && l(
          "microphone",
          "denied",
          "Microphone access denied by user"
        )), x && E(!0).catch(($) => {
        }), F && _(!0).catch(($) => {
        });
      }
  }), 0), U;
}
const Kt = 1e4, De = {
  // Enable WebRTC's built-in audio processing
  echoCancellation: !0,
  noiseSuppression: !0,
  autoGainControl: !0,
  // Audio quality optimized for voice
  sampleRate: 48e3,
  // High quality sample rate
  channelCount: 1,
  // Mono for voice calls (saves bandwidth)
  sampleSize: 16,
  // 16-bit audio
  // Latency optimization
  latency: 0.01
  // 10ms target latency
};
class Jt {
  constructor(e) {
    de(this, "name", "KrispNoiseFilter");
    de(this, "krispProcessor");
    de(this, "processedTrack");
    this.krispProcessor = e;
  }
  init(e) {
    return k(this, null, function* () {
      this.processedTrack = e.track;
    });
  }
  restart(e) {
    return k(this, null, function* () {
      yield this.init(e);
    });
  }
  destroy() {
    return k(this, null, function* () {
    });
  }
  setEnabled(e) {
    return k(this, null, function* () {
      return this.krispProcessor.setEnabled(e);
    });
  }
  getStats() {
    var e, a;
    return (a = (e = this.krispProcessor).getStats) == null ? void 0 : a.call(e);
  }
  setAggressiveness(e) {
    var a, n;
    return (n = (a = this.krispProcessor).setAggressiveness) == null ? void 0 : n.call(a, e);
  }
}
let me = null, ie = null;
const Ke = /* @__PURE__ */ new Set();
function Gt() {
  return k(this, null, function* () {
    return me || ie || (ie = Promise.race([
      // Dynamic import with timeout
      import(
        /* webpackIgnore: true */
        /* @vite-ignore */
        // @ts-expect-error ignore
        "https://cdn.jsdelivr.net/npm/@livekit/krisp-noise-filter@0.3.4/+esm"
      ).then((r) => (me = r, me)),
      // Timeout promise
      new Promise((r, e) => {
        setTimeout(() => {
          e(new Error("Enhanced Krisp load timeout"));
        }, Kt);
      })
    ]).catch((r) => (ie = null, null)), ie);
  });
}
var Ye = /* @__PURE__ */ ((r) => (r.Disconnected = "disconnected", r.Connecting = "connecting", r.Connected = "connected", r.Reconnecting = "reconnecting", r.SignalReconnecting = "signalReconnecting", r))(Ye || {});
function Xt(r) {
  return k(this, null, function* () {
    const e = yield Gt();
    if (!e)
      throw new Error("Krisp module not available");
    const { KrispNoiseFilter: a, isKrispNoiseFilterSupported: n } = e;
    if (!n())
      throw new Error("Krisp not supported in this browser");
    const s = a({
      model: "meeting",
      // Optimized for meeting scenarios
      aggressiveness: 0.7
      // Aggressive filtering for noisy environments
    }), o = new Jt(s);
    yield r.setProcessor(o), yield o.setEnabled(!0), Qt(s, r);
  });
}
function Qt(r, e) {
  const a = setInterval(() => {
    var n;
    try {
      r.getStats && r.getStats().cpuUsage > 0.8 && ((n = r.setAggressiveness) == null || n.call(r, 0.5));
    } catch (s) {
      clearInterval(a);
    }
  }, 5e3);
  e.on("ended", () => {
    clearInterval(a);
  });
}
function et() {
  const r = K(), e = b(
    "disconnected"
    /* Disconnected */
  ), a = b(null), n = Ke, s = (l) => {
    const u = l.name || "default", t = () => {
      e.value = "connected", a.value = null;
    }, h = (f) => {
      e.value = "disconnected", f === jt.SERVER_SHUTDOWN && (a.value = new Error(
        "Server is shutting down. Please try again later."
      ));
    }, i = () => {
      e.value = "reconnecting";
    }, m = () => {
      e.value = "connected", a.value = null;
    }, c = (f) => k(this, null, function* () {
      if (f.source === X.Source.Microphone && f.track instanceof It) {
        const E = f.trackSid || f.track.mediaStreamTrack.id;
        if (n.has(E))
          return;
        n.add(E);
        try {
          let R = !1;
          try {
            yield Xt(f.track), R = !0;
          } catch (L) {
          }
          yield f.track.mediaStreamTrack.applyConstraints({
            echoCancellation: !0,
            noiseSuppression: !R,
            autoGainControl: !0
          });
        } catch (R) {
          n.delete(E);
        }
      }
    }), C = (f) => {
      var E;
      if (f.source === X.Source.Microphone) {
        const R = f.trackSid || ((E = f.track) == null ? void 0 : E.mediaStreamTrack.id);
        R && n.has(R) && n.delete(R);
      }
    }, y = (f) => {
      e.value = f;
    };
    return l.on(j.Connected, t).on(j.Disconnected, h).on(j.Reconnecting, i).on(j.Reconnected, m).on(j.LocalTrackPublished, c).on(j.LocalTrackUnpublished, C).on(j.ConnectionStateChanged, y), () => {
      l.off(j.Connected, t).off(j.Disconnected, h).off(j.Reconnecting, i).off(j.Reconnected, m).off(j.LocalTrackPublished, c).off(j.LocalTrackUnpublished, C).off(j.ConnectionStateChanged, y), n.clear(), n.size === 0 && Ke.delete(u);
    };
  };
  ce((l) => {
    const u = r.value;
    if (!u)
      return;
    u.name, u.state === "connected" && e.value !== "connected" && (e.value = "connected");
    const t = s(u);
    l(t);
  });
  const o = () => e.value === "connected", w = () => k(this, null, function* () {
    const l = r.value;
    if (!(!l || !o()))
      try {
        const u = we(), t = l.localParticipant, h = (i) => Array.from(t.trackPublications.values()).some(
          (m) => m.source === i
        );
        u.isCameraEnabled.value && !h(X.Source.Camera) && (u.cameraStream.value && (u.cameraStream.value.getTracks().forEach((i) => {
          i.stop();
        }), u.cameraStream.value = null), yield l.localParticipant.setCameraEnabled(!0), yield new Promise((i) => setTimeout(i, 300))), u.isMicrophoneEnabled.value && !h(X.Source.Microphone) && (u.microphoneStream.value && (u.microphoneStream.value.getTracks().forEach((i) => {
          i.stop();
        }), u.microphoneStream.value = null), yield l.localParticipant.setMicrophoneEnabled(!0, ae(W({}, De), {
          deviceId: u.selectedMicrophone.value ? { exact: u.selectedMicrophone.value } : void 0
        })), yield new Promise((i) => setTimeout(i, 300))), u.isScreenShareEnabled.value && !h(X.Source.ScreenShare) && (u.screenShareStream.value && (u.screenShareStream.value.getTracks().forEach((i) => {
          i.stop();
        }), u.screenShareStream.value = null), yield l.localParticipant.setScreenShareEnabled(!0));
      } catch (u) {
        throw u;
      }
  });
  return {
    connectionState: e,
    connect: (l) => k(this, null, function* () {
      const u = r.value;
      if (!u)
        throw new Error("Room not available.");
      if (e.value === "connecting" || e.value === "connected")
        return { canJoin: !0, message: "Already connected to the session." };
      try {
        e.value = "connecting", a.value = null;
        const t = yield Ze.joinLiveSession(
          l.licenseId,
          l.participantToken
        );
        return t.canJoin ? (yield u.connect(
          t.serverUrl,
          l.participantToken,
          l.connectOptions
        ), o() && (yield new Promise((h) => setTimeout(h, 1e3)), l.skipMediaTransfer || (yield w())), t) : (e.value = "disconnected", t);
      } catch (t) {
        throw e.value = "disconnected", a.value = t, t;
      }
    }),
    disconnect: (l) => k(this, null, function* () {
      const u = r.value;
      if (u)
        try {
          yield u.disconnect(), yield Ze.leaveLiveSession(
            l.licenseId,
            l.participantToken
          ), e.value = "disconnected", a.value = null;
        } catch (t) {
          e.value = "disconnected";
        }
    }),
    error: a,
    isConnected: o,
    transferLocalMediaToRoom: w
  };
}
function Wa() {
  const r = K(), e = ee(/* @__PURE__ */ new Map()), a = ee(null), n = ee(null), s = (t) => {
    const h = () => {
      const C = /* @__PURE__ */ new Map();
      t.localParticipant && C.set(t.localParticipant.identity, t.localParticipant), t.remoteParticipants.forEach((y, f) => {
        C.set(f, y);
      }), e.value = C;
    };
    h();
    const i = () => {
      e.value = /* @__PURE__ */ new Map(), a.value = null, n.value = null;
    }, m = (C, y, f) => {
      a.value = {
        participant: f,
        track: C,
        publication: y,
        trackKind: C.kind
      };
    }, c = (C, y, f) => {
      n.value = {
        participant: f,
        track: C,
        publication: y,
        trackKind: C.kind
      };
    };
    return t.on(j.ParticipantConnected, h).on(j.ParticipantDisconnected, h).on(j.Connected, h).on(j.Disconnected, i).on(j.TrackSubscribed, m).on(j.TrackUnsubscribed, c), () => {
      t.off(j.ParticipantConnected, h).off(j.ParticipantDisconnected, h).off(j.Connected, h).off(j.Disconnected, i).off(j.TrackSubscribed, m).off(j.TrackUnsubscribed, c);
    };
  };
  ce((t) => {
    const h = r.value;
    if (!h) {
      e.value = /* @__PURE__ */ new Map();
      return;
    }
    const i = s(h);
    t(i);
  });
  const o = A(
    () => Array.from(e.value.values())
  ), w = A(() => e.value.size), p = A(() => {
    const t = r.value;
    return t == null ? void 0 : t.localParticipant;
  }), v = A(
    () => o.value.filter((t) => t !== p.value)
  );
  return {
    participants: o,
    participantCount: w,
    localParticipant: p,
    remoteParticipants: v,
    getParticipant: (t) => e.value.get(t),
    onTrackSubscribed: a,
    onTrackUnsubscribed: n,
    getParticipantMetadata: (t) => {
      const h = e.value.get(t), i = JSON.parse((h == null ? void 0 : h.metadata) || "{}");
      return ae(W({}, i), {
        identity: t
      });
    }
  };
}
const Fe = Vt("permission-denied");
function Re() {
  const r = K(), e = A(() => {
    var m;
    return (m = r.value) == null ? void 0 : m.localParticipant;
  }), a = b(!1), n = b(!1), s = b(!1), o = b(), w = b(), p = b();
  ce((m) => {
    const c = e.value;
    if (!c) {
      a.value = !1, n.value = !1, s.value = !1, o.value = void 0, w.value = void 0, p.value = void 0;
      return;
    }
    const y = _t(c).subscribe({
      next: (f) => {
        a.value = f.isCameraEnabled, n.value = f.isMicrophoneEnabled, s.value = f.isScreenShareEnabled, o.value = f.cameraTrack, w.value = f.microphoneTrack, p.value = c.getTrackPublication(
          X.Source.ScreenShare
        );
      },
      error: (f) => {
      }
    });
    m(() => {
      y.unsubscribe();
    });
  });
  const v = (m) => k(this, null, function* () {
    var y;
    const c = e.value;
    if (!c)
      throw new Error("Local participant not available");
    const C = ((y = c.permissions) == null ? void 0 : y.canPublishSources) || [];
    if (m && !C.includes(
      1
      /* CAMERA */
    )) {
      Fe.emit({ type: "camera" });
      return;
    }
    try {
      yield c.setCameraEnabled(m), m && we({ skipAutoEnable: !0 }).updateBrowserPermission("camera", "granted");
    } catch (f) {
      throw f;
    }
  }), l = () => k(this, null, function* () {
    yield v(!a.value);
  }), u = (m) => k(this, null, function* () {
    var y;
    const c = e.value;
    if (!c)
      throw new Error("Local participant not available");
    const C = ((y = c.permissions) == null ? void 0 : y.canPublishSources) || [];
    if (m && !C.includes(
      2
      /* MICROPHONE */
    )) {
      Fe.emit({ type: "microphone" });
      return;
    }
    try {
      yield c.setMicrophoneEnabled(m), m && we({ skipAutoEnable: !0 }).updateBrowserPermission("microphone", "granted");
    } catch (f) {
      throw f;
    }
  }), t = () => k(this, null, function* () {
    yield u(!n.value);
  }), h = (m) => k(this, null, function* () {
    var y;
    const c = e.value;
    if (!c)
      throw new Error("Local participant not available");
    const C = ((y = c.permissions) == null ? void 0 : y.canPublishSources) || [];
    if (m && !C.includes(
      3
      /* SCREEN_SHARE */
    )) {
      Fe.emit({ type: "screenshare" });
      return;
    }
    try {
      yield c.setScreenShareEnabled(m);
    } catch (f) {
      throw f;
    }
  });
  return {
    localParticipant: e,
    isCameraEnabled: a,
    isMicrophoneEnabled: n,
    isScreenShareEnabled: s,
    cameraTrack: o,
    microphoneTrack: w,
    screenShareTrack: p,
    toggleCamera: l,
    toggleMicrophone: t,
    toggleScreenShare: () => k(this, null, function* () {
      yield h(!s.value);
    }),
    setCameraEnabled: v,
    setMicrophoneEnabled: u,
    setScreenShareEnabled: h
  };
}
function Yt() {
  const r = () => {
    try {
      return !!(navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia && typeof navigator.mediaDevices.getUserMedia == "function");
    } catch (w) {
      return !1;
    }
  }, e = (w, p = 1e4) => k(this, null, function* () {
    try {
      if (!r())
        return {
          granted: !1,
          error: "Media APIs not supported in this environment",
          errorType: "not_supported"
        };
      const v = new Promise((t, h) => {
        setTimeout(() => h(new Error("Media access timeout")), p);
      }), l = navigator.mediaDevices.getUserMedia(w), u = yield Promise.race([l, v]);
      return u && u.getTracks().forEach((t) => {
        try {
          t.stop();
        } catch (h) {
        }
      }), { granted: !0 };
    } catch (v) {
      return v.name === "NotAllowedError" || v.name === "PermissionDeniedError" ? {
        granted: !1,
        error: "Permission denied by user",
        errorType: "permission_denied"
      } : v.name === "NotFoundError" || v.name === "DevicesNotFoundError" ? {
        granted: !1,
        error: "No device found",
        errorType: "device_not_found"
      } : v.name === "NotSupportedError" || v.name === "ConstraintNotSatisfiedError" ? {
        granted: !1,
        error: "Device constraints not supported",
        errorType: "not_supported"
      } : v.message === "Media access timeout" ? {
        granted: !1,
        error: "Media access timed out",
        errorType: "timeout"
      } : {
        granted: !1,
        error: v.message || "Unknown media error",
        errorType: "unknown"
      };
    }
  }), a = () => k(this, null, function* () {
    return yield e({
      video: {
        width: { ideal: 640 },
        height: { ideal: 480 },
        facingMode: "user"
      },
      audio: !1
    });
  }), n = () => k(this, null, function* () {
    return yield e({
      video: !1,
      audio: {
        echoCancellation: !0,
        noiseSuppression: !0,
        autoGainControl: !0
      }
    });
  });
  return {
    requestCameraPermission: a,
    requestMicrophonePermission: n,
    requestMediaPermissions: () => k(this, null, function* () {
      const w = yield a();
      yield new Promise((v) => setTimeout(v, 200));
      const p = yield n();
      return { camera: w, microphone: p };
    }),
    isMediaSupported: r,
    checkPermissionStatus: (w) => k(this, null, function* () {
      var p;
      try {
        if (!((p = navigator == null ? void 0 : navigator.permissions) != null && p.query))
          return "unknown";
        const v = w === "camera" ? "camera" : "microphone";
        return (yield navigator.permissions.query({
          name: v
        })).state;
      } catch (v) {
        return "unknown";
      }
    })
  };
}
function ea(r = {}) {
  const { skipAutoEnumeration: e = !1 } = r, a = K(), {
    requestCameraPermission: n,
    requestMicrophonePermission: s,
    requestMediaPermissions: o,
    isMediaSupported: w
  } = Yt(), p = b([]), v = b([]), l = b([]), u = b(""), t = b(""), h = b(""), i = b(!1), m = b(!1);
  let c = !1, C = !1;
  const y = (D = !1) => k(this, null, function* () {
    try {
      if (!w())
        return;
      let T = yield navigator.mediaDevices.enumerateDevices();
      const N = T.some((F) => F.kind === "videoinput" && !F.label) && !c, U = T.some((F) => F.kind === "audioinput" && !F.label) && !C;
      if ((N || U) && !D) {
        let F = !1;
        if (N && U) {
          const P = yield o();
          F = P.camera.granted && P.microphone.granted, c = P.camera.granted, C = P.microphone.granted;
        } else if (N) {
          const P = yield n();
          F = P.granted, c = P.granted;
        } else if (U) {
          const P = yield s();
          F = P.granted, C = P.granted;
        }
        F && (T = yield navigator.mediaDevices.enumerateDevices());
      }
      const M = [], S = [], x = [];
      T.forEach((F) => {
        let P = F.label;
        if (!P)
          switch (F.kind) {
            case "videoinput":
              P = c ? `Camera ${M.length + 1}` : "";
              break;
            case "audioinput":
              P = C ? `Microphone ${S.length + 1}` : "";
              break;
            case "audiooutput":
              P = `Speaker ${x.length + 1}`;
              break;
            default:
              P = `${F.kind} (${F.deviceId.slice(0, 8)})`;
          }
        if (P) {
          const $ = {
            deviceId: F.deviceId,
            label: P,
            kind: F.kind
          };
          switch (F.kind) {
            case "videoinput":
              M.push($);
              break;
            case "audioinput":
              S.push($);
              break;
            case "audiooutput":
              x.push($);
              break;
          }
        }
      }), p.value = M, v.value = S, l.value = x, i.value = M.length > 1, m.value = S.length > 1, !u.value && M.length > 0 && (u.value = M[0].deviceId), !t.value && S.length > 0 && (t.value = S[0].deviceId), !h.value && x.length > 0 && (h.value = x[0].deviceId);
    } catch (T) {
      throw T;
    }
  }), f = (D) => k(this, null, function* () {
    const T = a.value;
    if (!T || T.state !== "connected") {
      u.value = D;
      return;
    }
    try {
      yield T.switchActiveDevice("videoinput", D), u.value = D;
    } catch (N) {
      throw N;
    }
  }), E = (D) => k(this, null, function* () {
    const T = a.value;
    if (!T || T.state !== "connected") {
      t.value = D;
      return;
    }
    try {
      yield T.switchActiveDevice("audioinput", D), t.value = D;
    } catch (N) {
      throw N;
    }
  }), R = (D) => k(this, null, function* () {
    const T = a.value;
    if (!T || T.state !== "connected") {
      h.value = D;
      return;
    }
    try {
      yield T.switchActiveDevice("audiooutput", D), h.value = D;
    } catch (N) {
      throw N;
    }
  });
  let _ = null;
  const L = () => {
    _ && clearTimeout(_), _ = setTimeout(() => {
      y(!0);
    }, 500);
  };
  return Xe(() => {
    navigator.mediaDevices.addEventListener("devicechange", L), y(e);
  }), te(() => {
    navigator.mediaDevices.removeEventListener(
      "devicechange",
      L
    ), _ && clearTimeout(_);
  }), {
    videoDevices: p,
    audioInputDevices: v,
    audioOutputDevices: l,
    selectedVideoDevice: u,
    selectedAudioInputDevice: t,
    selectedAudioOutputDevice: h,
    enumerateDevices: y,
    switchVideoDevice: f,
    switchAudioInputDevice: E,
    switchAudioOutputDevice: R,
    hasMultipleCameras: i,
    hasMultipleMicrophones: m,
    updatePermissionStatus: (D, T) => {
      D === "video" ? c = T : D === "audio" && (C = T), y(!0);
    }
  };
}
function ta() {
  const r = K(), { localParticipant: e } = Re(), a = b(!1), n = b(), s = b(), o = !!(navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia);
  ce(() => {
    if (!e.value) {
      n.value = void 0, s.value = void 0, a.value = !1;
      return;
    }
    n.value = e.value.getTrackPublication(
      X.Source.ScreenShare
    ), s.value = e.value.getTrackPublication(
      X.Source.ScreenShareAudio
    ), a.value = !!(n.value && n.value.track && !n.value.isMuted);
  });
  const w = (...u) => k(this, [...u], function* (l = {}) {
    var i;
    const t = r.value, h = e.value;
    if (!t || !h)
      throw new Error("Room not connected");
    if (!o)
      throw new Error("Screen sharing is not supported in this browser");
    try {
      const m = {
        audio: (i = l.audio) != null ? i : !1,
        video: l.displaySurface ? { displaySurface: l.displaySurface } : !0
      };
      yield h.setScreenShareEnabled(!0, m);
    } catch (m) {
      if (!(m && typeof m == "object" && "name" in m && m.name === "NotAllowedError")) throw m;
    }
  }), p = () => k(this, null, function* () {
    const l = e.value;
    if (l)
      try {
        yield l.setScreenShareEnabled(!1);
      } catch (u) {
        throw u;
      }
  });
  return {
    isScreenShareEnabled: a,
    isScreenShareSupported: o,
    screenShareTrack: n,
    screenShareAudioTrack: s,
    toggleScreenShare: () => k(this, null, function* () {
      a.value ? yield p() : yield w();
    }),
    startScreenShare: w,
    stopScreenShare: p
  };
}
function Ka(r = {}) {
  const { skipMediaPermissions: e = !1 } = r, a = ke("controlsConfig", []), n = K(), s = ea({
    skipAutoEnumeration: e
  }), o = s.videoDevices, w = s.audioInputDevices, p = s.audioOutputDevices, v = s.enumerateDevices, l = s.updatePermissionStatus, { isScreenShareSupported: u } = ta(), t = we({
    skipAutoEnable: e,
    enabledControls: a
  });
  H(
    () => t.cameraPermission.value.state,
    (d, I) => {
      d === "granted" && I !== "granted" && l("video", !0);
    }
  ), H(
    () => t.microphonePermission.value.state,
    (d, I) => {
      d === "granted" && I !== "granted" && l("audio", !0);
    }
  ), H(
    () => s.selectedVideoDevice.value,
    (d) => {
      d && d !== t.selectedCamera.value && (t.selectedCamera.value = d);
    }
  ), H(
    () => s.selectedAudioInputDevice.value,
    (d) => {
      d && d !== t.selectedMicrophone.value && (t.selectedMicrophone.value = d);
    }
  ), H(
    () => s.selectedAudioOutputDevice.value,
    (d) => {
      d && d !== t.selectedSpeaker.value && (t.selectedSpeaker.value = d);
    }
  ), H(
    () => t.selectedCamera.value,
    (d) => {
      d && d !== s.selectedVideoDevice.value && (s.selectedVideoDevice.value = d);
    }
  ), H(
    () => t.selectedMicrophone.value,
    (d) => {
      d && d !== s.selectedAudioInputDevice.value && (s.selectedAudioInputDevice.value = d);
    }
  ), H(
    () => t.selectedSpeaker.value,
    (d) => {
      d && d !== s.selectedAudioOutputDevice.value && (s.selectedAudioOutputDevice.value = d);
    }
  );
  const { isConnected: h } = et();
  let i = null;
  try {
    i = Re();
  } catch (d) {
  }
  const m = A(() => h()), c = A(() => !e), C = A(() => m.value && i ? i.isCameraEnabled.value : t.isCameraEnabled.value), y = A(() => m.value && i ? i.isMicrophoneEnabled.value : t.isMicrophoneEnabled.value), f = A(() => m.value && i ? i.isScreenShareEnabled.value : t.isScreenShareEnabled.value), E = A({
    get: () => t.selectedCamera.value,
    set: (d) => {
      t.selectedCamera.value = d;
    }
  }), R = A({
    get: () => t.selectedMicrophone.value,
    set: (d) => {
      t.selectedMicrophone.value = d;
    }
  }), _ = A({
    get: () => t.selectedSpeaker.value,
    set: (d) => {
      t.selectedSpeaker.value = d;
    }
  }), L = A(() => t.cameraStream.value), z = A(() => t.microphoneStream.value), D = A(() => t.screenShareStream.value), T = A(() => o.value.length > 1), N = b(null), U = b(!1), M = b(!1), S = b(!1), x = b(1), F = b(!1), P = b(null), $ = () => {
    t.cameraStream.value && t.cameraStream.value.getTracks().forEach((I) => {
      I.readyState === "live" && I.stop();
    }), t.microphoneStream.value && t.microphoneStream.value.getTracks().forEach((I) => {
      I.readyState === "live" && I.stop();
    }), document.querySelectorAll(".camera-transition-overlay").forEach((I) => {
      I.parentElement && I.parentElement.removeChild(I);
    });
    const d = N.value;
    d && (d.src = "", N.value = null), U.value = !1;
  }, le = () => k(this, null, function* () {
    try {
      if (m.value && i)
        try {
          yield i.toggleCamera();
        } catch (d) {
          yield t.toggleCamera();
        }
      else
        yield t.toggleCamera();
    } catch (d) {
      throw new Error("Failed to toggle camera");
    }
  }), J = () => k(this, null, function* () {
    try {
      if (m.value && i)
        try {
          yield i.setCameraEnabled(!0);
        } catch (d) {
          yield t.setCameraEnabled(!0);
        }
      else
        yield t.setCameraEnabled(!0);
    } catch (d) {
      throw new Error("Failed to start camera");
    }
  }), je = () => {
    try {
      if (m.value && i)
        try {
          i.setCameraEnabled(!1);
        } catch (d) {
          t.setCameraEnabled(!1);
        }
      else
        t.setCameraEnabled(!1);
      $();
    } catch (d) {
      throw new Error("Failed to stop camera");
    }
  }, tt = () => k(this, null, function* () {
    try {
      if (m.value && i)
        try {
          yield i.toggleMicrophone();
        } catch (d) {
          yield t.toggleMicrophone();
        }
      else
        yield t.toggleMicrophone();
    } catch (d) {
      throw new Error("Failed to toggle microphone");
    }
  }), at = () => k(this, null, function* () {
    try {
      if (m.value && i)
        try {
          yield i.setMicrophoneEnabled(!0);
        } catch (d) {
          yield t.setMicrophoneEnabled(!0);
        }
      else
        yield t.setMicrophoneEnabled(!0);
    } catch (d) {
      throw new Error("Failed to start microphone");
    }
  }), rt = () => {
    try {
      if (m.value && i)
        try {
          i.setMicrophoneEnabled(!1);
        } catch (d) {
          t.setMicrophoneEnabled(!1);
        }
      else
        t.setMicrophoneEnabled(!1);
      $();
    } catch (d) {
      throw new Error("Failed to stop microphone");
    }
  }, nt = () => k(this, null, function* () {
    try {
      if (m.value && i)
        try {
          yield i.toggleScreenShare();
        } catch (d) {
          if (d instanceof Error && d.name === "NotAllowedError")
            throw d;
          yield t.toggleScreenShare();
        }
      else
        yield t.toggleScreenShare();
    } catch (d) {
      throw d && typeof d == "object" && "name" in d && d.name === "NotAllowedError" ? d : new Error("Failed to toggle screen share");
    }
  }), st = () => k(this, null, function* () {
    try {
      if (m.value && i)
        try {
          yield i.setScreenShareEnabled(!0);
        } catch (d) {
          if (d instanceof Error && d.name === "NotAllowedError")
            throw d;
          yield t.setScreenShareEnabled(!0);
        }
      else
        yield t.setScreenShareEnabled(!0);
    } catch (d) {
      throw d && typeof d == "object" && "name" in d && d.name === "NotAllowedError" ? d : new Error("Failed to start screen share");
    }
  }), ot = () => {
    try {
      if (m.value && i)
        try {
          i.setScreenShareEnabled(!1);
        } catch (d) {
          t.setScreenShareEnabled(!1);
        }
      else
        t.setScreenShareEnabled(!1);
    } catch (d) {
      throw new Error("Failed to stop screen share");
    }
  }, it = (d, I) => k(this, null, function* () {
    var B;
    try {
      if ((d === "camera" || d === "microphone") && (yield v(!1)), t.setDeviceSelection(d, I), m.value && ((B = n.value) == null ? void 0 : B.state) === "connected")
        try {
          switch (d) {
            case "camera":
              yield s.switchVideoDevice(I);
              break;
            case "microphone":
              yield s.switchAudioInputDevice(I);
              break;
            case "speaker":
              yield s.switchAudioOutputDevice(I);
              break;
          }
        } catch (q) {
        }
    } catch (q) {
      throw new Error(`Failed to change ${d} device`);
    }
  }), ct = () => k(this, null, function* () {
    if (o.value.length <= 1)
      throw new Error("Need at least two cameras to flip");
    try {
      const d = E.value, I = ["front", "selfie", "user", "face"], B = ["back", "rear", "environment", "main"], q = [], G = [], be = [];
      o.value.forEach((O) => {
        const ze = O.label.toLowerCase();
        I.some((Pe) => ze.includes(Pe)) ? q.push(O) : B.some((Pe) => ze.includes(Pe)) ? G.push(O) : be.push(O);
      });
      let Ee = o.value.find(
        (O) => O.deviceId === d
      );
      Ee || (Ee = o.value[0]);
      const Le = Ee.label.toLowerCase();
      let Ce = I.some(
        (O) => Le.includes(O)
      ), Me = B.some(
        (O) => Le.includes(O)
      );
      !Ce && !Me && (Ce = q.length > 0 && q.some((O) => O.deviceId === d), Me = G.length > 0 && G.some((O) => O.deviceId === d));
      let Q;
      Ce && G.length > 0 ? Q = G[0].deviceId : Me && q.length > 0 ? Q = q[0].deviceId : q.length > 0 && G.length > 0 ? Q = G[0].deviceId : o.value.length >= 2 ? Q = d === o.value[0].deviceId ? o.value[1].deviceId : o.value[0].deviceId : Q = d, C.value ? (t.cameraStream.value && t.cameraStream.value.getTracks().forEach((O) => {
        O.readyState === "live" && O.stop();
      }), yield je(), yield new Promise((O) => setTimeout(O, 200)), t.selectedCamera.value = Q, yield J()) : t.selectedCamera.value = Q;
    } catch (d) {
      throw $(), new Error("Failed to flip camera");
    }
  }), ue = () => k(this, null, function* () {
    try {
      const d = e || a.length === 0;
      if (yield v(d), c.value && !(o.value.some((B) => B.label) || w.value.some((B) => B.label)))
        try {
          const B = a.includes("camera"), q = a.includes("microphone");
          if (!B && !q)
            return;
          (yield navigator.mediaDevices.getUserMedia({
            video: B,
            audio: q
          })).getTracks().forEach((be) => {
            be.stop();
          }), yield v(!1);
        } catch (B) {
          B instanceof Error && B.name === "NotAllowedError" && (t.updateBrowserPermission(
            "camera",
            "denied",
            "Camera access denied by user"
          ), t.updateBrowserPermission(
            "microphone",
            "denied",
            "Microphone access denied by user"
          ));
        }
      o.value.forEach((I, B) => {
      }), o.value.length > 0 && !t.selectedCamera.value && (t.selectedCamera.value = o.value[0].deviceId), w.value.length > 0 && !t.selectedMicrophone.value && (t.selectedMicrophone.value = w.value[0].deviceId), p.value.length > 0 && !t.selectedSpeaker.value && (t.selectedSpeaker.value = p.value[0].deviceId);
    } catch (d) {
      d && typeof d == "object" && "name" in d && d.name === "NotAllowedError" && (t.updateBrowserPermission(
        "camera",
        "denied",
        "Camera access denied by user"
      ), t.updateBrowserPermission(
        "microphone",
        "denied",
        "Microphone access denied by user"
      ));
    }
  }), lt = (d) => {
    P.value = d, d && (d.volume = S.value ? 0 : x.value, d.muted = S.value, M.value && d.paused ? d.play().catch((I) => {
    }) : !M.value && !d.paused && d.pause());
  }, Ie = () => {
    F.value = !!(document.fullscreenElement || document.webkitFullscreenElement);
  }, ut = () => k(this, null, function* () {
    if (!P.value)
      throw new Error("No video element set");
    try {
      yield P.value.play(), M.value = !0;
    } catch (d) {
      throw d;
    }
  }), dt = () => {
    if (!P.value)
      throw new Error("No video element set");
    P.value.pause(), M.value = !1;
  }, mt = () => {
    M.value = !M.value, P.value && (M.value ? P.value.play().catch((d) => {
    }) : P.value.pause());
  }, vt = () => {
    S.value = !S.value, P.value && (P.value.muted = S.value, P.value.volume = S.value ? 0 : x.value);
  }, ht = (d) => {
    const I = Math.max(0, Math.min(1, d));
    x.value = I, S.value = I === 0, P.value && (P.value.volume = I, P.value.muted = S.value);
  }, _e = () => k(this, null, function* () {
    var I;
    const d = ((I = P.value) == null ? void 0 : I.parentElement) || P.value;
    if (!d)
      throw new Error("No element to fullscreen");
    try {
      d.requestFullscreen ? yield d.requestFullscreen() : d.webkitRequestFullscreen && (yield d.webkitRequestFullscreen()), F.value = !0;
    } catch (B) {
      throw B;
    }
  }), Ne = () => k(this, null, function* () {
    try {
      document.fullscreenElement ? yield document.exitFullscreen() : document.webkitFullscreenElement && (yield document.webkitExitFullscreen()), F.value = !1;
    } catch (d) {
      throw d;
    }
  }), pt = () => k(this, null, function* () {
    F.value ? yield Ne() : yield _e();
  }), ft = A(() => t.cameraPermission.value), gt = A(
    () => t.microphonePermission.value
  ), wt = A(
    () => t.screenSharePermission.value
  );
  return Xe(() => {
    ue(), navigator.mediaDevices.addEventListener("devicechange", ue);
  }), te(() => {
    navigator.mediaDevices.removeEventListener("devicechange", ue), document.removeEventListener("fullscreenchange", Ie), document.removeEventListener(
      "webkitfullscreenchange",
      Ie
    ), $();
  }), {
    // Device lists
    videoDevices: o,
    audioInputDevices: w,
    audioOutputDevices: p,
    // Media states
    isCameraEnabled: C,
    isMicrophoneEnabled: y,
    isScreenShareEnabled: f,
    isScreenShareSupported: u,
    hasMultipleCameras: T,
    // Browser permission states
    cameraPermission: ft,
    microphonePermission: gt,
    screenSharePermission: wt,
    // Selected devices
    selectedCamera: E,
    selectedMicrophone: R,
    selectedSpeaker: _,
    // Streams
    cameraStream: L,
    microphoneStream: z,
    screenShareStream: D,
    // Control methods
    toggleCamera: le,
    toggleMicrophone: tt,
    toggleScreenShare: nt,
    startCamera: J,
    stopCamera: je,
    startMicrophone: at,
    stopMicrophone: rt,
    startScreenShare: st,
    stopScreenShare: ot,
    // Device management
    handleDeviceChange: it,
    handleCameraFlip: ct,
    // Utility
    loadDevices: ue,
    ensureResourcesCleanup: $,
    // Attendee playback controls
    isPlaying: M,
    isMuted: S,
    volume: x,
    isFullscreen: F,
    currentVideoElement: P,
    // Playback methods
    togglePlay: mt,
    play: ut,
    pause: dt,
    toggleMute: vt,
    setVolume: ht,
    toggleFullscreen: pt,
    enterFullscreen: _e,
    exitFullscreen: Ne,
    setVideoElement: lt
  };
}
function aa(r = {}) {
  const e = K(), { connectionState: a } = et(), n = b([]);
  let s = 0;
  const o = (u) => {
    const t = (h, i, m, c) => {
      var y;
      const C = {
        id: `msg-${s++}`,
        data: h,
        participant: i ? {
          identity: i.identity,
          name: i.name,
          sid: i.sid
        } : void 0,
        topic: c,
        timestamp: Date.now()
      };
      n.value.push(C), (y = r.onDataReceived) == null || y.call(r, C);
    };
    return u.on(j.DataReceived, t), () => {
      u.off(j.DataReceived, t);
    };
  };
  ce((u) => {
    const t = e.value;
    if (!t) return;
    const h = o(t);
    u(h);
  });
  const w = (h, ...i) => k(this, [h, ...i], function* (u, t = {}) {
    const m = e.value;
    if (!m || a.value !== Ye.Connected)
      throw new Error("Room not connected");
    const { topic: c, reliable: C = !0, destinationIdentities: y } = t;
    try {
      y && y.length > 0 ? yield m.localParticipant.publishData(u, {
        reliable: C,
        topic: c,
        destinationIdentities: y
      }) : yield m.localParticipant.publishData(u, { reliable: C, topic: c });
    } catch (f) {
      throw f;
    }
  }), p = (h, ...i) => k(this, [h, ...i], function* (u, t = {}) {
    const m = new TextEncoder().encode(u);
    yield w(m, t);
  }), v = (h, ...i) => k(this, [h, ...i], function* (u, t = {}) {
    const m = JSON.stringify(u);
    yield p(m, t);
  }), l = () => {
    n.value = [], s = 0;
  };
  return te(() => {
    l();
  }), {
    messages: n,
    sendData: w,
    sendText: p,
    sendJSON: v,
    clearMessages: l
  };
}
function Ja() {
  const r = b([]), e = K(), a = aa({
    onDataReceived: (o) => {
      var w, p, v, l, u;
      if (o.topic === "chat")
        try {
          const t = new TextDecoder().decode(o.data), h = JSON.parse(t), i = (p = e.value) == null ? void 0 : p.remoteParticipants.get(
            ((w = o.participant) == null ? void 0 : w.identity) || ""
          ), m = JSON.parse(
            (i == null ? void 0 : i.metadata) || "{}"
          ), c = {
            id: o.id,
            text: h.text,
            senderName: ((v = o.participant) == null ? void 0 : v.name) || ((l = o.participant) == null ? void 0 : l.identity) || "Unknown",
            senderIdentity: ((u = o.participant) == null ? void 0 : u.identity) || "unknown",
            senderIdentityType: m == null ? void 0 : m.identityType,
            senderAvatar: m == null ? void 0 : m.avatar,
            senderRole: m == null ? void 0 : m.role,
            timestamp: o.timestamp,
            isOwn: !1
          };
          r.value.push(c);
        } catch (t) {
        }
    }
  });
  return {
    messages: r,
    sendMessage: (o) => k(this, null, function* () {
      if (!o.trim()) return;
      const w = e.value, p = w == null ? void 0 : w.localParticipant;
      yield a.sendJSON({ text: o }, { topic: "chat" });
      const v = JSON.parse((p == null ? void 0 : p.metadata) || "{}"), l = {
        id: `chat-${Date.now()}-${Math.random().toString(36).substring(2, 6)}`,
        text: o,
        senderName: (p == null ? void 0 : p.name) || "Anonymous",
        senderIdentity: p == null ? void 0 : p.identity,
        senderIdentityType: v == null ? void 0 : v.identityType,
        senderAvatar: v == null ? void 0 : v.avatar,
        senderRole: v == null ? void 0 : v.role,
        timestamp: Date.now(),
        isOwn: !0
      };
      return r.value.push(l), l;
    }),
    clearMessages: () => {
      r.value = [], a.clearMessages();
    }
  };
}
const [Ga, ra] = xe(
  (r = "attendee") => {
    const e = b({
      role: r,
      title: "",
      description: ""
    }), a = A(() => e.value.role), n = A(() => e.value.role === "host"), s = A(() => e.value.role === "attendee");
    return {
      state: e,
      role: a,
      isHost: n,
      isAttendee: s,
      setRole: (p) => {
        e.value.role = p;
      },
      setRoomInfo: (p, v) => {
        e.value.title = p, e.value.description = v;
      }
    };
  }
);
function Xa() {
  const r = ra();
  if (!r)
    throw new Error("useRoomState must be used within a RoomProvider");
  return r;
}
const na = ["data-speaking", "data-audio-level"], sa = ["src", "alt"], oa = /* @__PURE__ */ ye({
  __name: "AttendeeAvatar",
  props: {
    name: { default: "Attendee" },
    image: {},
    size: { default: "medium" },
    isSpeaking: { type: Boolean, default: !1 },
    backgroundColor: { default: "rgba(255, 255, 255, 0.1)" },
    textColor: { default: "#e8eaed" },
    borderColor: { default: "" },
    showSpeakingAnimation: { type: Boolean, default: !0 },
    audioLevel: { default: 0 },
    speakingRingColor: { default: "#34a853" }
  },
  setup(r) {
    Ft((t) => ({
      "1b35bcb4": e.speakingRingColor,
      "2b1aafb6": o.value.start,
      "590b6e32": o.value.middle,
      "1505815e": o.value.end
    }));
    const e = r, a = b(!1), n = b(!1), s = A(() => {
      const t = e.showSpeakingAnimation && e.isSpeaking;
      return e.isSpeaking, t;
    }), o = A(() => {
      const t = e.speakingRingColor, h = t.match(/hsl\((\d+),\s*(\d+)%,\s*(\d+)%\)/);
      if (h) {
        const [, i, m, c] = h;
        return {
          start: `hsla(${i}, ${m}%, ${c}%, 0.7)`,
          middle: `hsla(${i}, ${m}%, ${c}%, 0.2)`,
          end: `hsla(${i}, ${m}%, ${c}%, 0)`
        };
      }
      return {
        start: t + "70",
        // 70% opacity
        middle: t + "33",
        // 20% opacity
        end: t + "00"
        // 0% opacity
      };
    }), w = () => {
      a.value = !0, n.value = !1;
    }, p = () => {
      n.value = !0, a.value = !1;
    }, v = A(() => e.image && n.value && !a.value), l = () => {
      n.value = !1, a.value = !1;
    };
    H(
      () => e.image,
      () => {
        l();
      }
    );
    const u = A(() => {
      const t = e.name.trim();
      if (!t) return "?";
      const h = t.split(/\s+/);
      return h.length >= 2 ? (h[0][0] + h[1][0]).toUpperCase() : t.length === 1 ? t.toUpperCase() : t.slice(0, 2).toUpperCase();
    });
    return (t, h) => (V(), Z("div", {
      class: Qe(["attendee-avatar", [`size-${t.size}`, { "is-speaking": s.value }]]),
      "data-speaking": t.isSpeaking,
      "data-audio-level": t.audioLevel
    }, [
      g("div", {
        class: "avatar-icon",
        style: re({
          backgroundColor: v.value ? "transparent" : t.backgroundColor,
          color: v.value ? "transparent" : t.textColor,
          borderColor: t.borderColor,
          borderWidth: t.borderColor ? "2px" : "0",
          borderStyle: t.borderColor ? "solid" : "none"
        })
      }, [
        t.image ? (V(), Z("img", {
          key: 0,
          src: t.image,
          alt: t.name,
          style: re({ opacity: n.value && !a.value ? 1 : 0 }),
          class: "avatar-image",
          onLoad: p,
          onError: w
        }, null, 44, sa)) : Ae("", !0),
        v.value ? Ae("", !0) : (V(), Z("span", {
          key: 1,
          class: "avatar-initials",
          style: re({
            color: t.textColor,
            backgroundColor: "transparent"
          })
        }, Y(u.value), 5))
      ], 4),
      s.value ? (V(), Z("div", {
        key: 0,
        class: "speaking-ring",
        style: re({ transform: `scale(${1 + t.audioLevel * 0.15})` })
      }, null, 4)) : Ae("", !0)
    ], 10, na));
  }
}), Qa = /* @__PURE__ */ Se(oa, [["__scopeId", "data-v-1d9b6940"]]), ia = ["disabled", "title"], ca = /* @__PURE__ */ ye({
  __name: "ControlButton",
  props: {
    active: { type: Boolean, default: !1 },
    danger: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    title: { default: "" },
    noBackground: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(r) {
    const e = r;
    return (a, n) => (V(), Z("button", {
      class: Qe(["control-button", {
        active: a.active,
        danger: a.danger,
        disabled: a.disabled,
        "no-background": e.noBackground
      }]),
      disabled: a.disabled,
      title: a.title,
      onClick: n[0] || (n[0] = (s) => a.$emit("click"))
    }, [
      Dt(a.$slots, "default", {}, void 0, !0)
    ], 10, ia));
  }
}), Ya = /* @__PURE__ */ Se(ca, [["__scopeId", "data-v-46a84f32"]]), la = { class: "permission-prompt" }, ua = { class: "assetsdrmclient:pt-4 assetsdrmclient:px-2" }, da = { class: "assetsdrmclient:text-white assetsdrmclient:font-semibold assetsdrmclient:text-base assetsdrmclient:my-0" }, ma = { class: "assetsdrmclient:text-white assetsdrmclient:text-sm assetsdrmclient:leading-5 assetsdrmclient:mb-6 assetsdrmclient:mt-0" }, va = { class: "permission-modal-content" }, ha = { class: "illustration-section" }, pa = {
  key: 0,
  class: "safari-illustration"
}, fa = {
  key: 1,
  class: "chrome-illustration"
}, ga = { class: "content-section" }, wa = { class: "modal-title" }, ka = { class: "modal-message" }, ya = { class: "instructions" }, Sa = {
  key: 0,
  class: "instruction-list"
}, ba = { class: "instruction-item" }, Ea = { class: "step-text" }, Ca = {
  key: 1,
  class: "instruction-list"
}, Ma = /* @__PURE__ */ ye({
  __name: "PermissionPrompt",
  props: {
    cameraPermission: {},
    microphonePermission: {},
    platform: {}
  },
  emits: ["close"],
  setup(r, { emit: e }) {
    const a = r, n = e, s = A(() => a.platform === "ios" || a.platform === "android"), o = A(() => {
      const m = navigator.userAgent.toLowerCase();
      return m.includes("safari") && !m.includes("chrome") ? "Safari" : m.includes("chrome") ? "Chrome" : m.includes("firefox") ? "Firefox" : "Browser";
    }), w = A(() => o.value === "Safari"), p = A(() => window.location.hostname), v = A(() => {
      const m = a.cameraPermission.state === "denied" || a.cameraPermission.state === "prompt", c = a.microphonePermission.state === "denied" || a.microphonePermission.state === "prompt";
      return m && c ? `${o.value} is blocked from using your microphone and camera` : m ? `${o.value} is blocked from using your camera` : c ? `${o.value} is blocked from using your microphone` : "Media access required";
    }), l = A(() => {
      const m = a.cameraPermission.state === "denied" || a.cameraPermission.state === "prompt", c = a.microphonePermission.state === "denied" || a.microphonePermission.state === "prompt";
      return m && c ? "To join this meeting, you need to allow access to your microphone and camera." : m ? "To join this meeting with video, you need to allow access to your camera." : c ? "To join this meeting, you need to allow access to your microphone." : "Media access is required to join this meeting.";
    }), u = A(() => {
      const m = a.cameraPermission.state === "denied" || a.cameraPermission.state === "prompt", c = a.microphonePermission.state === "denied" || a.microphonePermission.state === "prompt";
      return m && c ? "Unable to access camera and microphone" : m ? "Unable to access camera" : c ? "Unable to access microphone" : "Unable to access media";
    }), t = A(() => {
      const m = a.cameraPermission.state === "denied" || a.cameraPermission.state === "prompt", c = a.microphonePermission.state === "denied" || a.microphonePermission.state === "prompt";
      if (a.platform === "ios") {
        if (m && c)
          return 'Allow app to access your camera and microphone from device menu: "Settings" - "Privacy" - "Camera" and "Microphone"';
        if (m)
          return 'Allow app to access your camera from device menu: "Settings" - "Privacy" - "Camera"';
        if (c)
          return 'Allow app to access your microphone from device menu: "Settings" - "Privacy" - "Microphone"';
      } else if (a.platform === "android") {
        if (m && c)
          return 'Allow app to access your camera and microphone from device menu: "Settings" - "Apps" - "app" - "Permissions" - "Camera" and "Microphone"';
        if (m)
          return 'Allow app to access your camera from device menu: "Settings" - "Apps" - "Permissions" - "Camera"';
        if (c)
          return 'Allow app to access your microphone from device menu: "Settings" - "Apps" - "Permissions" - "Microphone"';
      }
      return "Please enable camera and microphone access in your device settings.";
    }), h = () => {
      n("close");
    }, i = () => {
      n("close");
    };
    return (m, c) => (V(), Z("div", la, [
      s.value ? (V(), Be(Ve, {
        key: 0,
        to: "body"
      }, [
        g("div", {
          class: "assetsdrmclient:fixed assetsdrmclient:inset-0 assetsdrmclient:bg-black/80 assetsdrmclient:flex assetsdrmclient:items-center assetsdrmclient:justify-center assetsdrmclient:z-[99999]",
          onClick: h
        }, [
          g("div", {
            class: "assetsdrmclient:bg-gray-800/70 assetsdrmclient:rounded-2xl assetsdrmclient:w-60 assetsdrmclient:text-center",
            onClick: c[0] || (c[0] = qe(() => {
            }, ["stop"]))
          }, [
            g("div", ua, [
              g("h4", da, Y(u.value), 1),
              g("p", ma, Y(t.value), 1)
            ]),
            g("div", {
              class: "assetsdrmclient:flex assetsdrmclient:justify-center assetsdrmclient:border-t assetsdrmclient:border-gray-700 assetsdrmclient:p-3 assetsdrmclient:text-blue-600 assetsdrmclient:cursor-pointer",
              onClick: i
            }, " Okay ")
          ])
        ])
      ])) : (V(), Be(Ve, {
        key: 1,
        to: "body"
      }, [
        g("div", {
          class: "permission-modal-overlay",
          onClick: h
        }, [
          g("div", {
            class: "permission-modal",
            onClick: c[1] || (c[1] = qe(() => {
            }, ["stop"]))
          }, [
            g("button", {
              class: "close-button",
              onClick: h
            }, c[2] || (c[2] = [
              g("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                g("path", {
                  d: "M18 6L6 18M6 6L18 18",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)
            ])),
            g("div", va, [
              g("div", ha, [
                w.value ? (V(), Z("div", pa, c[3] || (c[3] = [
                  g("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    width: "300",
                    height: "300",
                    viewBox: "0 0 1080 1080"
                  }, [
                    g("defs", null, [
                      g("path", {
                        id: "a",
                        d: "M325.25 383.21c82.843 0 150-67.157 150-150s-67.157-150-150-150-150 67.157-150 150 67.157 150 150 150Z"
                      })
                    ]),
                    g("g", {
                      fill: "none",
                      "fill-rule": "evenodd"
                    }, [
                      g("path", {
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        d: "M0 0h1080v1080H0z"
                      }),
                      g("g", {
                        stroke: "#191C1E",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "3"
                      }, [
                        g("path", { d: "M116.5 973.246V791.83a72.32 72.32 0 0 1 72.32-72.33h767.26M116.5 853.55h839.58" }),
                        g("path", {
                          d: "M206.81 804.85c10.416 0 18.86-8.444 18.86-18.86 0-10.416-8.444-18.86-18.86-18.86-10.416 0-18.86 8.444-18.86 18.86 0 10.416 8.444 18.86 18.86 18.86h0Z",
                          fill: "#FF8669",
                          "fill-rule": "nonzero"
                        }),
                        g("path", {
                          d: "M270.32 804.85c10.416 0 18.86-8.444 18.86-18.86 0-10.416-8.444-18.86-18.86-18.86-10.416 0-18.86 8.444-18.86 18.86 0 10.416 8.444 18.86 18.86 18.86h0Z",
                          fill: "#FFB929",
                          "fill-rule": "nonzero"
                        }),
                        g("path", {
                          d: "M333.84 804.85c10.416 0 18.86-8.444 18.86-18.86 0-10.416-8.444-18.86-18.86-18.86-10.416 0-18.86 8.444-18.86 18.86 0 10.416 8.444 18.86 18.86 18.86h0Z",
                          fill: "#6DD58C",
                          "fill-rule": "nonzero"
                        }),
                        g("path", { d: "M490.18 783.44h-63.69m29.13 29.13-29.13-29.13 29.13-29.12m72.7 29.12h63.69m-29.13 29.13 29.13-29.13-29.13-29.12" })
                      ]),
                      g("path", {
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        d: "M116.681 276.5h65.007M469.447 276.5h486.84M469.18 186.5h486.84M116.299 186.5h65.771"
                      }),
                      g("mask", {
                        id: "b",
                        fill: "#fff"
                      }, [
                        g("use", { "xlink:href": "#a" })
                      ]),
                      g("use", {
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "xlink:href": "#a"
                      }),
                      g("g", { mask: "url(#b)" }, [
                        g("path", {
                          fill: "#C2E7FF",
                          d: "M223 169h207v126H223z"
                        }),
                        g("path", {
                          stroke: "#191C1E",
                          "stroke-width": "3",
                          "stroke-linecap": "square",
                          d: "M162 295.5h325M162.345 169.5h325.31"
                        }),
                        g("g", {
                          fill: "#000",
                          "fill-rule": "nonzero"
                        }, [
                          g("path", { d: "M270.085 251.88c-3.263 0-6.197-.953-8.8-2.86-2.603-1.907-4.418-4.583-5.445-8.03l5.72-2.31c.587 2.2 1.632 3.997 3.135 5.39 1.503 1.393 3.318 2.09 5.445 2.09 1.98 0 3.658-.513 5.033-1.54 1.375-1.027 2.062-2.438 2.062-4.235 0-1.65-.605-3.016-1.815-4.097-1.21-1.082-3.3-2.136-6.27-3.163l-2.475-.88c-2.677-.953-4.904-2.282-6.683-3.988-1.778-1.704-2.667-3.969-2.667-6.792a9.88 9.88 0 0 1 1.567-5.39c1.046-1.65 2.512-2.952 4.4-3.905 1.889-.953 4.025-1.43 6.408-1.43 3.41 0 6.142.834 8.195 2.502 2.053 1.669 3.447 3.548 4.18 5.638l-5.445 2.31c-.367-1.32-1.137-2.457-2.31-3.41-1.173-.953-2.695-1.43-4.565-1.43-1.797 0-3.318.477-4.565 1.43-1.247.953-1.87 2.163-1.87 3.63 0 1.357.56 2.484 1.678 3.383 1.118.898 2.85 1.75 5.197 2.557l2.53.88c3.373 1.173 5.977 2.695 7.81 4.565 1.833 1.87 2.75 4.363 2.75 7.48 0 2.567-.65 4.72-1.953 6.463-1.301 1.741-2.97 3.034-5.005 3.877-2.034.843-4.115 1.265-6.242 1.265ZM298.08 251.88c-2.017 0-3.813-.394-5.39-1.182-1.577-.789-2.805-1.898-3.685-3.328-.88-1.43-1.32-3.062-1.32-4.895 0-1.943.513-3.62 1.54-5.032 1.027-1.412 2.42-2.494 4.18-3.245 1.76-.752 3.722-1.128 5.885-1.128 1.65 0 3.144.156 4.482.468 1.339.311 2.411.669 3.218 1.072v-1.485c0-1.797-.66-3.254-1.98-4.373-1.32-1.118-3.025-1.677-5.115-1.677-1.43 0-2.787.32-4.07.963-1.283.641-2.31 1.512-3.08 2.612l-4.07-3.135c1.21-1.723 2.814-3.062 4.813-4.015 1.998-.953 4.189-1.43 6.572-1.43 4.033 0 7.16 1 9.377 2.998 2.219 1.998 3.328 4.794 3.328 8.387V251h-5.775v-3.465h-.33c-.807 1.247-1.962 2.282-3.465 3.108-1.503.825-3.208 1.237-5.115 1.237Zm1.045-4.84c1.467 0 2.805-.357 4.015-1.072a7.646 7.646 0 0 0 2.833-2.888 7.857 7.857 0 0 0 1.017-3.905c-.88-.513-1.888-.917-3.025-1.21a14.253 14.253 0 0 0-3.575-.44c-2.31 0-4.006.458-5.087 1.375-1.082.917-1.623 2.127-1.623 3.63 0 1.32.495 2.402 1.485 3.245.99.843 2.31 1.265 3.96 1.265ZM321.95 228.12h-5.115v-5.17h5.115v-2.31c0-2.933.908-5.243 2.723-6.93 1.815-1.687 4.115-2.53 6.902-2.53 1.577 0 3.025.22 4.345.66v5.775a20.492 20.492 0 0 0-1.87-.632 7.314 7.314 0 0 0-1.98-.248c-1.21 0-2.218.385-3.025 1.155-.807.77-1.21 1.852-1.21 3.245v1.815h7.04v5.17h-7.04V251h-5.885v-22.88ZM348.24 251.88c-2.017 0-3.813-.394-5.39-1.182-1.577-.789-2.805-1.898-3.685-3.328-.88-1.43-1.32-3.062-1.32-4.895 0-1.943.513-3.62 1.54-5.032 1.027-1.412 2.42-2.494 4.18-3.245 1.76-.752 3.722-1.128 5.885-1.128 1.65 0 3.144.156 4.483.468 1.338.311 2.41.669 3.217 1.072v-1.485c0-1.797-.66-3.254-1.98-4.373-1.32-1.118-3.025-1.677-5.115-1.677-1.43 0-2.787.32-4.07.963-1.283.641-2.31 1.512-3.08 2.612l-4.07-3.135c1.21-1.723 2.814-3.062 4.813-4.015 1.998-.953 4.189-1.43 6.572-1.43 4.033 0 7.16 1 9.377 2.998 2.219 1.998 3.328 4.794 3.328 8.387V251h-5.775v-3.465h-.33c-.807 1.247-1.962 2.282-3.465 3.108-1.503.825-3.208 1.237-5.115 1.237Zm1.045-4.84c1.467 0 2.805-.357 4.015-1.072a7.646 7.646 0 0 0 2.832-2.888 7.857 7.857 0 0 0 1.018-3.905c-.88-.513-1.888-.917-3.025-1.21a14.253 14.253 0 0 0-3.575-.44c-2.31 0-4.006.458-5.088 1.375-1.081.917-1.622 2.127-1.622 3.63 0 1.32.495 2.402 1.485 3.245.99.843 2.31 1.265 3.96 1.265ZM369.47 222.95h5.61v4.125h.33c.623-1.43 1.696-2.612 3.217-3.547a9.235 9.235 0 0 1 4.923-1.403c1.283 0 2.42.183 3.41.55v6.16c-1.503-.66-2.952-.99-4.345-.99-2.09 0-3.813.807-5.17 2.42-1.357 1.613-2.035 3.575-2.035 5.885V251h-5.94v-28.05ZM394.935 218.825c-1.1 0-2.044-.394-2.833-1.182-.788-.789-1.182-1.733-1.182-2.833s.394-2.035 1.182-2.805a3.91 3.91 0 0 1 2.833-1.155c1.1 0 2.044.385 2.833 1.155.788.77 1.182 1.705 1.182 2.805s-.394 2.044-1.182 2.833c-.789.788-1.733 1.182-2.833 1.182Zm-2.97 4.125h5.94V251h-5.94v-28.05Z" })
                        ])
                      ]),
                      g("path", {
                        d: "M511.74 439.52 317.2 272.28a8 8 0 0 0-13.22 6.07v266a9.51 9.51 0 0 0 17.17 5.65l59.92-81.16 50.64 99.84a17.998 17.998 0 0 0 24.24 7.92h0c2.115-1.068 4-2.542 5.544-4.339a18.016 18.016 0 0 0 4.293-13.124 17.98 17.98 0 0 0-1.907-6.777l-48.75-96.1h90.4a9.516 9.516 0 0 0 8.931-6.209 9.517 9.517 0 0 0-2.721-10.531h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M937.11 402.88c0-19.507-15.813-35.32-35.32-35.32-19.507 0-35.32 15.813-35.32 35.32v83.58c0 19.507 15.813 35.32 35.32 35.32 19.507 0 35.32-15.813 35.32-35.32v-83.58Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FF8669",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M956.51 487.95a54.72 54.72 0 0 1-109.44 0m54.72 54.72v31.84m-35.32 0h70.64",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M722.69 444.65v-33.56a16.685 16.685 0 0 0-16.74-16.66H594.06a16.702 16.702 0 0 0-11.843 4.849 16.682 16.682 0 0 0-4.927 11.811v121.34c.04 9.213 7.537 16.652 16.75 16.62h111.91c9.212.032 16.706-7.408 16.74-16.62v-28.85l43.34 31.66a11.923 11.923 0 0 0 12.42 1.068 11.925 11.925 0 0 0 6.58-10.588V419.28a11.924 11.924 0 0 0-6.83-10.71 11.916 11.916 0 0 0-12.61 1.53l-42.9 34.55Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FF8669",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      })
                    ])
                  ], -1)
                ]))) : (V(), Z("div", fa, c[4] || (c[4] = [
                  g("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "300",
                    height: "300",
                    viewBox: "0 0 1080 1080"
                  }, [
                    g("g", {
                      fill: "none",
                      "fill-rule": "evenodd"
                    }, [
                      g("path", {
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        d: "M0 0h1080v1080H0z"
                      }),
                      g("path", {
                        d: "M120.5 942.36V210.83a72.32 72.32 0 0 1 72.32-72.33h767.26",
                        fill: "#FFF",
                        "fill-rule": "nonzero"
                      }),
                      g("path", {
                        d: "M120.5 942.36V210.83a72.32 72.32 0 0 1 72.32-72.33h767.26",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M960.08 256.93h-110c-12.94 0-23.43-10.49-23.43-23.43v-71.56a23.428 23.428 0 0 0-23.43-23.44H536.29a23.433 23.433 0 0 0-23.43 23.44v71.56c-.001 12.94-10.49 23.429-23.43 23.43H120.5v137.62h839.58",
                        fill: "#FFF",
                        "fill-rule": "nonzero"
                      }),
                      g("path", {
                        d: "M960.08 256.93h-110c-12.94 0-23.43-10.49-23.43-23.43v-71.56a23.428 23.428 0 0 0-23.43-23.44H536.29a23.433 23.433 0 0 0-23.43 23.44v71.56c-.001 12.94-10.49 23.429-23.43 23.43H120.5v137.62h839.58",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M210.81 223.85c10.416 0 18.86-8.444 18.86-18.86 0-10.416-8.444-18.86-18.86-18.86-10.416 0-18.86 8.444-18.86 18.86 0 10.416 8.444 18.86 18.86 18.86h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FF8669",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M274.32 223.85c10.416 0 18.86-8.444 18.86-18.86 0-10.416-8.444-18.86-18.86-18.86-10.416 0-18.86 8.444-18.86 18.86 0 10.416 8.444 18.86 18.86 18.86h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFB929",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M337.84 223.85c10.416 0 18.86-8.444 18.86-18.86 0-10.416-8.444-18.86-18.86-18.86-10.416 0-18.86 8.444-18.86 18.86 0 10.416 8.444 18.86 18.86 18.86h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#6DD58C",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M670.77 475.25c82.578 0 149.52-66.942 149.52-149.52 0-82.578-66.942-149.52-149.52-149.52-82.578 0-149.52 66.942-149.52 149.52 0 82.578 66.942 149.52 149.52 149.52Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M460.21 353.89a38.369 38.369 0 0 1-64.265-31.835 38.364 38.364 0 0 1 28.046-33.32 38.368 38.368 0 0 1 41.119 14.355",
                        fill: "#FFF",
                        "fill-rule": "nonzero"
                      }),
                      g("path", {
                        d: "M460.21 353.89a38.369 38.369 0 0 1-64.265-31.835 38.364 38.364 0 0 1 28.046-33.32 38.368 38.368 0 0 1 41.119 14.355",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#191C1E",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "m470.57 298.9 2.52 16.75-15.95-5.72z"
                      }),
                      g("path", {
                        d: "M236.18 329.44h-63.69m29.13 29.13-29.13-29.13 29.13-29.12m72.7 29.12h63.69m-29.13 29.13 29.13-29.13-29.13-29.12",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M354.11 741.88c0-19.507-15.813-35.32-35.32-35.32-19.507 0-35.32 15.813-35.32 35.32v83.58c0 19.507 15.813 35.32 35.32 35.32 19.507 0 35.32-15.813 35.32-35.32v-83.58Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FF8669",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M373.51 826.95a54.72 54.72 0 1 1-109.44 0m54.72 54.72v31.84m-35.32 0h70.64",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "m430.59 520.1-42.9 34.55v-33.56a16.683 16.683 0 0 0-16.74-16.66H259.06a16.7 16.7 0 0 0-11.843 4.849 16.682 16.682 0 0 0-4.927 11.811v121.34c.04 9.213 7.537 16.652 16.75 16.62h111.91c9.212.032 16.706-7.408 16.74-16.62v-28.85l43.34 31.66a11.923 11.923 0 0 0 12.42 1.068 11.925 11.925 0 0 0 6.58-10.588V529.28a11.924 11.924 0 0 0-6.83-10.71 11.916 11.916 0 0 0-12.61 1.53h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FF8669",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M590.9 274.8h369.18V376H590.9c-27.95-.001-50.61-22.66-50.61-50.61h0c.012-27.943 22.667-50.589 50.61-50.59h0Z",
                        stroke: "#C2E7FF",
                        "stroke-width": "3",
                        fill: "#C2E7FF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M625.31 322.08h-27.15a7.88 7.88 0 0 0-7.88 7.88v17.19a7.88 7.88 0 0 0 7.88 7.88h27.15a7.88 7.88 0 0 0 7.88-7.88v-17.19a7.88 7.88 0 0 0-7.88-7.88h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M595.13 322.09v-12.86a16.764 16.764 0 0 1 16.76-16.8c9.256 0 16.76 7.504 16.76 16.76v12.86",
                        fill: "#FFF",
                        "fill-rule": "nonzero"
                      }),
                      g("path", {
                        d: "M595.13 322.09v-12.86a16.764 16.764 0 0 1 16.76-16.8h0c9.256 0 16.76 7.504 16.76 16.76v12.86",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M670.77 475.25c82.578 0 149.52-66.942 149.52-149.52 0-82.578-66.942-149.52-149.52-149.52-82.578 0-149.52 66.942-149.52 149.52 0 82.578 66.942 149.52 149.52 149.52Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M521.29 325.74a149.005 149.005 0 0 0 39.1 100.87h220.75c51.762-56.63 52.26-143.25 1.15-200.47h-223a149.001 149.001 0 0 0-38 99.6h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M562.74 326.15a79.606 79.606 0 0 0 23.314 56.286 79.608 79.608 0 0 0 56.286 23.314h154.75c30.743-48.56 30.945-110.44.52-159.2H642.34c-43.962 0-79.6 35.638-79.6 79.6h0Z",
                        stroke: "#C2E7FF",
                        "stroke-width": "3",
                        fill: "#C2E7FF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M670.77 475.25c82.578 0 149.52-66.942 149.52-149.52 0-82.578-66.942-149.52-149.52-149.52-82.578 0-149.52 66.942-149.52 149.52 0 82.578 66.942 149.52 149.52 149.52Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("path", {
                        d: "M884.74 525.52 690.2 358.28a8 8 0 0 0-13.22 6.07v266a9.51 9.51 0 0 0 17.17 5.65l59.92-81.16 50.64 99.84a17.998 17.998 0 0 0 24.24 7.92h0c2.115-1.068 4-2.542 5.544-4.339a18.016 18.016 0 0 0 4.293-13.124 17.98 17.98 0 0 0-1.907-6.777l-48.75-96.1h90.4a9.516 9.516 0 0 0 8.931-6.209 9.517 9.517 0 0 0-2.721-10.531h0Z",
                        stroke: "#191C1E",
                        "stroke-width": "3",
                        fill: "#FFF",
                        "fill-rule": "nonzero",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }),
                      g("g", {
                        transform: "translate(623 279)",
                        stroke: "#191C1E",
                        "stroke-width": "4"
                      }, [
                        g("ellipse", {
                          transform: "rotate(180 84.632 20.5)",
                          cx: "84.632",
                          cy: "20.5",
                          rx: "18.368",
                          ry: "18.5"
                        }),
                        g("path", {
                          "stroke-linecap": "square",
                          d: "M1 20h63"
                        }),
                        g("circle", {
                          cx: "20.5",
                          cy: "60.5",
                          r: "18.5"
                        }),
                        g("path", {
                          "stroke-linecap": "square",
                          d: "M105 60H42"
                        })
                      ])
                    ])
                  ], -1)
                ])))
              ]),
              g("div", ga, [
                g("h3", wa, Y(v.value), 1),
                g("p", ka, Y(l.value), 1),
                g("div", ya, [
                  w.value ? (V(), Z("div", Sa, [
                    g("div", ba, [
                      c[5] || (c[5] = g("div", { class: "step-number" }, "1", -1)),
                      g("div", Ea, ' Click the "' + Y(o.value) + '" menu and open "Settings for ' + Y(p.value) + '" ', 1)
                    ]),
                    c[6] || (c[6] = g("div", { class: "instruction-item" }, [
                      g("div", { class: "step-number" }, "2"),
                      g("div", { class: "step-text" }, "Allow microphone and camera")
                    ], -1))
                  ])) : (V(), Z("div", Ca, c[7] || (c[7] = [
                    g("div", { class: "instruction-item" }, [
                      g("div", { class: "step-number" }, "1"),
                      g("div", { class: "step-text" }, [
                        He(" Click the "),
                        g("svg", {
                          width: "20",
                          height: "20",
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "inline-icon"
                        }, [
                          g("g", {
                            fill: "none",
                            "fill-rule": "evenodd",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [
                            g("circle", {
                              cx: "15",
                              cy: "8",
                              r: "2.6"
                            }),
                            g("path", {
                              "stroke-linecap": "round",
                              d: "M2.5 8h8.5"
                            }),
                            g("circle", {
                              cx: "5",
                              cy: "15",
                              r: "2.6"
                            }),
                            g("path", {
                              "stroke-linecap": "round",
                              d: "M17.5 15h-8.5"
                            })
                          ])
                        ]),
                        He(" settings icon in your browser's address bar ")
                      ])
                    ], -1),
                    g("div", { class: "instruction-item" }, [
                      g("div", { class: "step-number" }, "2"),
                      g("div", { class: "step-text" }, " Clear blocked microphone and camera permissions ")
                    ], -1)
                  ])))
                ])
              ])
            ])
          ])
        ])
      ]))
    ]));
  }
}), er = /* @__PURE__ */ Se(Ma, [["__scopeId", "data-v-39df96a1"]]);
function Pa() {
  const r = b(0);
  let e = null, a = null;
  const n = (o) => {
    s();
    try {
      const w = window.AudioContext || window.webkitAudioContext, p = new w(), v = p.createMediaStreamSource(o), l = p.createAnalyser();
      l.fftSize = 32, l.smoothingTimeConstant = 0.8, v.connect(l);
      const u = l.frequencyBinCount, t = new Uint8Array(u);
      e = () => {
        v.disconnect(), p.close();
      };
      const h = () => {
        l.getByteFrequencyData(t);
        let i = 0;
        for (let c = 0; c < t.length; c++) {
          const C = t[c];
          i += C * C;
        }
        const m = Math.sqrt(i / t.length) / 255;
        r.value = Math.min(m * 2, 1);
      };
      a = window.setInterval(h, 1e3 / 30);
    } catch (w) {
      s();
    }
  }, s = () => {
    a && (clearInterval(a), a = null), e && (e(), e = null), r.value = 0;
  };
  return te(() => {
    s();
  }), {
    audioLevel: r,
    // Only for preview visualization
    startAnalyzing: n,
    stopAnalyzing: s
  };
}
const Ta = { class: "audio-meter-container" }, Aa = { class: "mic-icon" }, Fa = { class: "audio-meter-bar-background" }, Da = /* @__PURE__ */ ye({
  __name: "AudioMeter",
  props: {
    iconColor: { default: "#ffffff" },
    iconSize: { default: 18 }
  },
  setup(r) {
    const e = r, a = Pa(), n = A(() => Math.min(100, Math.round(a.audioLevel.value * 100)));
    return (s, o) => (V(), Z("div", Ta, [
      g("div", Aa, [
        xt(Nt, {
          color: e.iconColor,
          size: e.iconSize
        }, null, 8, ["color", "size"])
      ]),
      g("div", Fa, [
        g("div", {
          class: "audio-meter-bar-fill",
          style: re({ width: `${n.value}%` })
        }, null, 4),
        g("div", {
          class: "audio-meter-thumb",
          style: re({ left: `${n.value}%` })
        }, null, 4)
      ])
    ]));
  }
}), tr = /* @__PURE__ */ Se(Da, [["__scopeId", "data-v-908e1937"]]), ve = /* @__PURE__ */ new WeakMap(), he = /* @__PURE__ */ new WeakMap();
function ar(r = "file-transfer") {
  Math.random().toString(36).substring(7);
  const e = K(), { localParticipant: a } = Re(), n = () => {
    const c = e.value;
    if (!c) return null;
    he.has(c) || he.set(c, /* @__PURE__ */ new Map());
    const C = he.get(c);
    if (!C.has(r)) {
      const y = b([]), f = (E) => {
        y.value = [...y.value, E];
      };
      C.set(r, { messages: y, addMessage: f });
    }
    return C.get(r);
  }, s = n(), o = (s == null ? void 0 : s.messages) || b([]), w = b(/* @__PURE__ */ new Map()), p = /* @__PURE__ */ new Map(), v = b(!1), l = b(0), u = () => {
    const c = e.value;
    if (!c)
      return;
    ve.has(c) || ve.set(c, /* @__PURE__ */ new Set());
    const C = ve.get(c);
    if (!C.has(r))
      try {
        c.registerByteStreamHandler(r, (y, f) => k(this, null, function* () {
          var P;
          const E = y.info, R = [];
          y.onProgress = ($) => {
            w.value.set(E.id, $);
          };
          try {
            for (var M = $e(y), S, x, F; S = !(x = yield M.next()).done; S = !1) {
              const $ = x.value;
              R.push($);
            }
          } catch (x) {
            F = [x];
          } finally {
            try {
              S && (x = M.return) && (yield x.call(M));
            } finally {
              if (F)
                throw F[0];
            }
          }
          const _ = new Blob(R, { type: E.mimeType }), L = URL.createObjectURL(_);
          p.set(E.id, _);
          const z = c.remoteParticipants.get(f.identity) || c.localParticipant, D = (z == null ? void 0 : z.name) || (z == null ? void 0 : z.identity) || f.identity, T = JSON.parse((z == null ? void 0 : z.metadata) || "{}"), N = {
            id: `chat-${Date.now()}-${Math.random().toString(36).substring(2, 6)}`,
            streamId: E.id,
            fileName: E.name || "Unnamed File",
            fileSize: E.size || _.size,
            mimeType: E.mimeType || "application/octet-stream",
            senderName: D,
            senderAvatar: T == null ? void 0 : T.avatar,
            senderRole: T == null ? void 0 : T.role,
            senderIdentity: f.identity,
            senderIdentityType: T == null ? void 0 : T.identityType,
            timestamp: E.timestamp,
            isOwn: f.identity === ((P = a.value) == null ? void 0 : P.identity),
            url: L
          }, U = n();
          U ? U.addMessage(N) : o.value.push(N), w.value.delete(E.id);
        })), C.add(r);
      } catch (y) {
        y && typeof y == "object" && "message" in y && y.message.includes("already been set") && C.add(r);
      }
  }, t = (c, C, y) => k(this, null, function* () {
    const f = e.value, E = a.value;
    if (!f || !E)
      throw new Error("Room or participant not available");
    try {
      v.value = !0, l.value = 0;
      const _ = {
        topic: y || r,
        mimeType: c.type,
        onProgress: (U) => {
          l.value = U, w.value.set("upload", U);
        }
      }, L = yield E.sendFile(c, _), z = URL.createObjectURL(c), D = JSON.parse(E.metadata || "{}"), T = {
        id: `chat-${Date.now()}-${Math.random().toString(36).substring(2, 6)}`,
        streamId: L.id,
        fileName: c.name,
        fileSize: c.size,
        mimeType: c.type,
        senderName: E.name || E.identity,
        senderIdentity: E.identity,
        senderIdentityType: D == null ? void 0 : D.identityType,
        senderAvatar: D == null ? void 0 : D.avatar,
        senderRole: D == null ? void 0 : D.role,
        timestamp: Date.now(),
        isOwn: !0,
        url: z
      }, N = n();
      return N ? N.addMessage(T) : o.value.push(T), w.value.delete("upload"), v.value = !1, l.value = 0, T;
    } catch (R) {
      throw v.value = !1, l.value = 0, R;
    }
  }), h = () => {
    o.value.forEach((C) => {
      C.url && URL.revokeObjectURL(C.url);
    });
    const c = n();
    c ? c.messages.value = [] : o.value = [], p.clear(), w.value.clear();
  }, i = () => {
    const c = e.value;
    if (!c)
      return null;
    c.state === "connected" && u();
    const C = () => {
      u();
    };
    c.on(j.Connected, C);
    const y = () => {
      ve.delete(c), he.delete(c);
    };
    return c.on(j.Disconnected, y), () => {
      c.off(j.Connected, C), c.off(j.Disconnected, y);
    };
  };
  let m = null;
  return e.value && (m = i()), te(() => {
    h(), m && m();
  }), {
    fileMessages: o,
    fileProgress: w,
    isUploading: v,
    uploadProgress: l,
    sendFile: t,
    clearFileMessages: h
  };
}
function xa(r) {
  return r.startsWith("image/") ? "images" : r.startsWith("video/") ? "videos" : r.startsWith("audio/") ? "audios" : r.startsWith("text/") ? "texts" : r.includes("pdf") || r.includes("document") || r.includes("spreadsheet") || r.includes("presentation") || r.includes("msword") || r.includes("ms-excel") || r.includes("ms-powerpoint") || r.includes("officedocument") ? "documents" : "unknowns";
}
function Ra(r, e) {
  return k(this, null, function* () {
    return new Promise((a, n) => {
      const s = new XMLHttpRequest();
      s.open("PUT", e, !0), s.setRequestHeader("Content-Type", r.type), s.onload = () => {
        s.status === 200 ? a() : n(new Error(`Upload failed with status: ${s.status}`));
      }, s.onerror = () => n(new Error("Upload failed")), s.send(r);
    });
  });
}
function ja(r, e = 3, a = 1e3) {
  return k(this, null, function* () {
    let n;
    for (let s = 1; s <= e; s++)
      try {
        return yield r();
      } catch (o) {
        if (n = o, s === e) break;
        const w = a * Math.pow(2, s - 1);
        yield new Promise((p) => setTimeout(p, w));
      }
    throw n;
  });
}
function rr() {
  const r = ke("assetId", b(""));
  return {
    recordMessage: (a) => k(this, null, function* () {
      try {
        if (!r.value)
          return;
        let n;
        return yield ja(() => k(this, null, function* () {
          let s;
          if (a.attachment) {
            const w = yield (yield fetch(a.attachment.url)).blob(), p = new File([w], a.attachment.name, {
              type: a.attachment.type
            }), v = xa(a.attachment.type), l = yield Lt.getUploadSignedUrl({
              assetId: r.value,
              type: v,
              mimeType: a.attachment.type,
              bucketType: "own"
            });
            yield Ra(p, l.signedUrl), s = `https://storage.googleapis.com/${l.bucket}/${l.path}`;
          }
          n = {
            identity: a.senderIdentity,
            text: a.text,
            senderName: a.senderName,
            senderAvatar: a.senderAvatar,
            senderRole: a.senderRole,
            senderIdentity: a.senderIdentity,
            senderIdentityType: a.senderIdentityType,
            timestamp: a.timestamp,
            attachments: a.attachment ? [
              {
                id: a.attachment.id,
                name: a.attachment.name,
                size: a.attachment.size,
                type: a.attachment.type,
                url: s
              }
            ] : void 0
          }, yield ge.addChat(r.value, n);
        })), n;
      } catch (n) {
      }
    })
  };
}
let pe = null, fe = !1;
function nr() {
  const r = b(!1), e = b(fe), a = b(!1), n = b(null);
  let s = null, o = null;
  const w = () => k(this, null, function* () {
    return fe ? (e.value = !0, !0) : pe || (pe = new Promise((u, t) => {
      try {
        if (r.value = !0, n.value = null, window.EmojiMart) {
          fe = !0, e.value = !0, u(!0);
          return;
        }
        const h = document.createElement("script");
        h.src = "https://cdn.jsdelivr.net/npm/emoji-mart@5.6.0/dist/browser.js", h.async = !0, h.onload = () => {
          if (window.EmojiMart)
            fe = !0, e.value = !0, u(!0);
          else {
            const i = "emoji-mart failed to initialize";
            n.value = i, t(new Error(i));
          }
        }, h.onerror = () => {
          const i = "Failed to load emoji-mart from CDN";
          n.value = i, t(new Error(i));
        }, document.head.appendChild(h);
      } catch (h) {
        const i = h instanceof Error ? h.message : "Unknown error loading emoji-mart";
        n.value = i, t(new Error(i));
      } finally {
        r.value = !1;
      }
    }), pe);
  }), p = (m, c, ...C) => k(this, [m, c, ...C], function* (u, t, h = {}, i = {}) {
    try {
      if (v(), !(yield w()))
        throw new Error("Failed to load emoji picker");
      const f = W({
        theme: "auto",
        set: "native",
        previewPosition: "none",
        skinTonePosition: "search",
        searchPosition: "sticky",
        perLine: 8,
        emojiSize: 24,
        emojiButtonSize: 32,
        maxFrequentRows: 2,
        locale: "en"
      }, h), E = ae(W({}, f), {
        data: () => k(this, null, function* () {
          const M = yield fetch(
            "https://cdn.jsdelivr.net/npm/@emoji-mart/data"
          );
          if (!M.ok)
            throw new Error("Failed to load emoji data");
          return M.json();
        }),
        onEmojiSelect: (M) => {
          t(M), v();
        },
        onClickOutside: () => {
          v();
        }
      });
      if (s = new window.EmojiMart.Picker(E), yield new Promise((M) => setTimeout(M, 100)), !s)
        throw new Error("Failed to create emoji picker instance");
      o = document.createElement("div");
      const _ = W(W({}, {
        position: "fixed",
        // Use fixed instead of absolute for better positioning
        zIndex: "9999",
        // Higher z-index to ensure visibility
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "10px",
        overflow: "hidden",
        backgroundColor: "white"
        // Ensure background
      }), i);
      Object.assign(o.style, _);
      const L = u.getBoundingClientRect(), z = window.innerHeight, D = window.innerWidth, T = 400, N = 352;
      L.bottom + T > z && L.top > T ? o.style.bottom = `${z - L.top + 8}px` : o.style.top = `${L.bottom + 8}px`;
      let U = L.left;
      U + N > D && (U = D - N - 8), U < 8 && (U = 8), o.style.left = `${U}px`, o.appendChild(s), document.body.appendChild(o), a.value = !0;
    } catch (y) {
      const f = y instanceof Error ? y.message : "Failed to show emoji picker";
      n.value = f;
    }
  }), v = () => {
    try {
      o && (o.parentNode && o.parentNode.removeChild(o), o = null), s && (s = null), a.value = !1;
    } catch (u) {
      o = null, s = null, a.value = !1;
    }
  }, l = (m, c, ...C) => k(this, [m, c, ...C], function* (u, t, h = {}, i = {}) {
    a.value ? v() : yield p(u, t, h, i);
  });
  return te(() => {
    v();
  }), {
    isLoading: r,
    isLoaded: e,
    isOpen: a,
    error: n,
    showPicker: p,
    hidePicker: v,
    togglePicker: l,
    loadEmojiMart: w
  };
}
var Ia = /* @__PURE__ */ ((r) => (r.MESSAGE_RECEIVED = "message_received", r.PARTICIPANT_JOINED = "participant_joined", r.SCREEN_SHARE_STARTED = "screen_share_started", r.HAND_RAISED = "hand_raised", r))(Ia || {});
const _a = {
  message_received: "https://storage.googleapis.com/revex-assets-drm-staging/live-session-assets/sounds/new-message.mp3",
  participant_joined: "https://storage.googleapis.com/revex-assets-drm-staging/live-session-assets/sounds/participant-joined.mp3",
  screen_share_started: "https://storage.googleapis.com/revex-assets-drm-staging/live-session-assets/sounds/screen-share.mp3",
  hand_raised: "https://storage.cloud.google.com/revex-assets-drm-staging/live-session-assets/sounds/hand_raise1.mp3"
};
function sr() {
  return {
    playSound: (e) => k(this, null, function* () {
      try {
        const a = _a[e];
        if (!a)
          return;
        const n = new Audio(a);
        n.volume = 0.3;
        const s = n.play();
        s !== void 0 && (yield s);
      } catch (a) {
      }
    })
  };
}
function or(r = {}) {
  const {
    pageSize: e = 50,
    autoLoadOnMount: a = !0,
    onError: n,
    onHistoryLoaded: s
  } = r, o = ke("assetId", b("")), w = b([]), p = b(!0), v = b(void 0), l = b(!1), u = b(!1), t = b(!1), h = b(null), i = (f) => {
    var E;
    return {
      id: f._id,
      text: f.text || "",
      senderName: f.senderName || "Unknown",
      senderAvatar: f.senderAvatar || "",
      senderRole: f.senderRole,
      senderIdentity: f.senderIdentity,
      senderIdentityType: f.senderIdentityType || "",
      timestamp: f.timestamp,
      isOwn: !1,
      // Will be determined by the component based on current user
      attachment: (E = f.attachments) != null && E[0] ? {
        id: f.attachments[0].id || "",
        name: f.attachments[0].name || "",
        size: f.attachments[0].size || 0,
        type: f.attachments[0].type || "",
        url: f.attachments[0].url || ""
      } : void 0
    };
  }, m = () => k(this, null, function* () {
    if (!(!o.value || l.value))
      try {
        l.value = !0, h.value = null;
        const f = {
          limit: e
          // No cursor for initial load - gets most recent messages
        }, E = yield ge.getChats(o.value, f), R = E.chats.map(i);
        R.sort((_, L) => _.timestamp - L.timestamp), w.value = R, p.value = E.hasMore, v.value = E.nextCursor, s == null || s(R, !0);
      } catch (f) {
        const E = f instanceof Error ? f.message : "Failed to load chat history";
        h.value = E, n == null || n(f instanceof Error ? f : new Error(E));
      } finally {
        l.value = !1;
      }
  }), c = () => k(this, null, function* () {
    if (!(!o.value || u.value || !p.value || !v.value))
      try {
        u.value = !0, h.value = null;
        const f = {
          limit: e,
          cursor: v.value
        }, E = yield ge.getChats(o.value, f), R = E.chats.map(i);
        R.sort((_, L) => _.timestamp - L.timestamp), w.value = [...R, ...w.value], p.value = E.hasMore, v.value = E.nextCursor, s == null || s(R, !1);
      } catch (f) {
        const E = f instanceof Error ? f.message : "Failed to load more messages";
        h.value = E, n == null || n(f instanceof Error ? f : new Error(E));
      } finally {
        u.value = !1;
      }
  }), C = () => k(this, null, function* () {
    if (!(!o.value || t.value))
      try {
        t.value = !0, h.value = null, v.value = void 0, p.value = !0;
        const f = {
          limit: e
        }, E = yield ge.getChats(o.value, f), R = E.chats.map(i);
        R.sort((_, L) => _.timestamp - L.timestamp), w.value = R, p.value = E.hasMore, v.value = E.nextCursor, s == null || s(R, !0);
      } catch (f) {
        const E = f instanceof Error ? f.message : "Failed to refresh chat";
        h.value = E, n == null || n(f instanceof Error ? f : new Error(E));
      } finally {
        t.value = !1;
      }
  }), y = () => {
    w.value = [], p.value = !0, v.value = void 0, l.value = !1, u.value = !1, t.value = !1, h.value = null;
  };
  return H(
    o,
    (f) => {
      f && a && (y(), m());
    },
    { immediate: !0 }
  ), {
    // Data
    historicalMessages: w,
    hasMore: p,
    nextCursor: v,
    // Loading states
    isInitialLoading: l,
    isLoadingMore: u,
    isRefreshing: t,
    // Error state
    error: h,
    // Methods
    loadInitialHistory: m,
    loadMoreHistory: c,
    refresh: C,
    reset: y
  };
}
function ir(r, e) {
  const a = /* @__PURE__ */ new Map();
  return r.forEach((s) => {
    a.set(s.id, s);
  }), e.forEach((s) => {
    a.set(s.id, s);
  }), Array.from(a.values()).sort((s, o) => s.timestamp - o.timestamp);
}
export {
  Qa as A,
  Ye as C,
  Ia as N,
  De as O,
  er as P,
  Re as a,
  ea as b,
  Wa as c,
  Ha as d,
  K as e,
  Za as f,
  qa as g,
  Ka as h,
  Pa as i,
  we as j,
  Ya as k,
  tr as l,
  Ja as m,
  ar as n,
  rr as o,
  nr as p,
  or as q,
  ir as r,
  sr as s,
  Va as t,
  et as u,
  aa as v,
  Ga as w,
  Vt as x,
  Xa as y
};
